<script>
import Vue from "vue";
import { mapActions, mapGetters } from "vuex";
import moment from "moment";
import PageHeader from "@/components/page-header";
import UserCheckinAction from "@/components/sharedCells/userAction/UserCheckinAction";
import ExportProgress from "@/components/grid/ExportProgress";
import Locations from "@/components/dashboard/Locations";
import Compliances from "@/components/dashboard/Compliances";
import ComplianceFillIn from "@/components/dashboard/complianceFillIn";
import ActionCell from "@/components/dashboard/ActionCell";
import Actions from "@/components/dashboard/ActionsForDailyLog";
import ImageCell from "@/components/sharedCells/ImageCell";
// import Modal from "@/components/modal/Modal";
import { dashboardColumns } from "@/utils/dataSource";
// import ColumnsSwitcher from "@/components/sharedCells/ColumnsSwitcher";
import { exportExel } from "@/utils/mixins/exportMixin";
import store from "@/state/store";
import VaccineDetails from "@/components/users/VaccineDetails";

import { default as Button } from "devextreme-vue/button";
import DxDropDownButton from "devextreme-vue/drop-down-button";
import AlertFoundActiveSession from "@/components/emergency/AlertFoundActiveSession";
import MassactionIndex from "../dailylogUsersMassaction/MassactionIndex.vue";
import AttendanceModeDeniedAccess from "@/components/sharedCells/userAction/AttendanceModeDeniedAccess.vue";
import AclErrorModals from "@/router/views/dailylogUsersMassaction/modals/acl/Index.vue";
import smileysJson from "@/router/views/customFields/smileys.json";
import MasterDetailGrid from "./MasterDetailGrid.vue";
import UpdateScanCustomFieldsModal from "@/components/dashboard/UpdateScanCustomFieldsModal.vue";
import QuickSignIn from "@/router/views/dashboards/QuickSignIn/QuickSignIn.vue";
// import attendanceModeService from "@/services/attendanceMode";
// import integrationService from "@/services/integration";
import addVisitNotesModal from "@/components/dashboard/addVisitNotes";
import editExpectedVisitModal from "@/components/dashboard/editExpectedVisit";
import deleteExpectedVisitModal from "@/components/dashboard/deleteExpectedVisit";
import PrintBadgeForm from "@/router/views/dailylogUsersMassaction/printBadgeForm.vue";

import DxDataGrid, {
  DxFilterRow,
  DxHeaderFilter,
  DxColumnChooser,
  DxExport,
  DxPaging,
  DxPager,
  DxEditing,
  DxStateStoring,
  DxScrolling,
  DxSelection,
  DxToolbar,
  DxItem,
  DxMasterDetail,
} from "devextreme-vue/data-grid";
import "jspdf-autotable";
import CustomStore from "devextreme/data/custom_store";
const dataGridRef = "dataGrid";
const subGridRef = "dataGrid";
import "whatwg-fetch";
import { countryCodes } from "./codes";
import Api from "../../../services/Api";
import { deletedUserMixin } from "@/utils/mixins/deletedUserMixin";
import { rfidFormatterMixin } from "@/utils/mixins/rfidFormatterMixin";
import { breakpoints } from "@/utils/mixins/breakpoints";

function isNotEmpty(value) {
  return value !== undefined && value !== null && value !== "";
}

function debounce(func, wait) {
  let timeout;
  return function (...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(this, args), wait);
  };
}

export default {
  title: "Dashboard",
  props: [
    "iconAction",
    "rows",
    "columns",
    "xlsxName",
    "getDataAction",
    "loading",
    "hasCheckbox",
    "hasBEpagination",
    "hasBEfiltering",
    "hasBEsorting",
    "hasDetails",
    "gridSettings",
    "hasHeaderCheckable",
    "isRowCheckable",
    "detailKeyId",
    "columnsList",
    "hasCustomDetails",
    "isHoverable",
    "isSelectable",
    "selectable",
    "displayTempretureSettings",
    "hasBEexport",
    "recordsCount",
    "mobileView",
    "gridName",
    "hasDocuments",
    "vaccineColumn",
  ],
  mixins: [exportExel, rfidFormatterMixin, deletedUserMixin, breakpoints],
  components: {
    MassactionIndex,
    PageHeader,
    UserCheckinAction,
    ExportProgress,
    DxScrolling,
    ActionCell,
    Actions,
    ImageCell,
    Compliances,
    Locations,
    ComplianceFillIn,
    VaccineDetails,
    DxDataGrid,
    DxFilterRow,
    DxHeaderFilter,
    DxColumnChooser,
    DxExport,
    DxPaging,
    DxPager,
    DxEditing,
    DxStateStoring,
    DxSelection,
    DxToolbar,
    DxItem,
    Button,
    DxDropDownButton,
    DxMasterDetail,
    AlertFoundActiveSession,
    AttendanceModeDeniedAccess,
    AclErrorModals,
    MasterDetailGrid,
    UpdateScanCustomFieldsModal,
    QuickSignIn,
    addVisitNotesModal,
    editExpectedVisitModal,
    deleteExpectedVisitModal,
    PrintBadgeForm
  },
  data() {
    return {
      usersForPrint: [],
      rtlEnabled: false,
      gridEmptyMessage : this.$t('common.grid.loadingData'),
      needUpdateScrollPosition: false,
      resendLoading: false,
      allLabels: [],
      massactionItems: [
        { modalId: "signinMassaction", text: this.$t("common.signInOut") },
      ],
      allFilterHeaders: ["UserType", "Status", "CurrentJourneyStage", "Area", "Site"],
      hideLoader: false,
      focusedComponent: null,
      editingVisitId: null,
      commonActions: [],
      selectedRows: [],
      previousSelectedRowKeys: [],
      isSelectAllClicked: false,
      selectedRowKeys: [],
      noOfSelectedRows: 0,
      isSelectionMode: false,
      selectedRowsData: [],
      userRole: "",
      showUserData: true,
      modalLoading: null,
      firstName: "",
      lastName: "",
      visitRejected: false,
      visitApproved: false,
      scan_time: null,
      rejectionReason: null,
      action_by: null,
      userTypeId: "",
      id: "",
      areaId: "",
      visitId: null,
      manageVisit: null,
      isEditVisit: null,
      fullName: "",
      dateValue: null,
      timeValue: null,
      offset: null,
      daysDiff: null,
      preRegTimeZone: null,
      dateValidation: false,
      timeValidation: false,
      checkValidation: false,
      changeVisitReason: "",
      isLoading: false,
      visitModalTitle: "",
      visitData: null,
      isExport: false,
      checkInStatus: "",
      checkInData: "",
      pattern: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
      max: 255,
      open: false,
      countryCodes,
      dateRange: [
        moment(new Date().setHours(0, 0, 0, 0))
          .utc()
          .format("YYYY-MM-DD HH:mm:ss"),
        moment(new Date().setHours(23, 59, 59, 999))
          .utc()
          .format("YYYY-MM-DD HH:mm:ss"),
      ],
      dateRangeLocal: [
        moment
          .utc(new Date(Date.now()))
          .tz(moment.tz.guess())
          .format("YYYY-MM-DD"),
        moment
          .utc(new Date(Date.now()))
          .tz(moment.tz.guess())
          .format("YYYY-MM-DD"),
      ],
      resetPhone(rowData, value) {
        rowData.PhoneNumber = "";
        this.defaultSetCellValue(rowData, value);
      },
      finalParams: {},
      title: "Dashboard",
      visitNotes: "",
      visitNotesCopy: "",
      isDisabled: false,
      pageInit: true,
      visitNotesAdded: "",
      editedUser: null,
      isEdit: false,
      isWalkinUser: false,
      isSystemUser: false,
      phone: "",
      visit_id: "",
      isServerSideExport: false,
      finalFilterObject: {},
      showAttendanceCodeColumn: false,
      showReasonColumn: false,
      multipleFilters: [
        {
          Date: {
            start: moment(new Date().setHours(23, 59, 59, 999))
              .utc()
              .format("YYYY-MM-DD HH:mm:ss"),
            end: moment(new Date().setHours(0, 0, 0, 0))
              .utc()
              .format("YYYY-MM-DD HH:mm:ss"),
          },
        },
      ],
      sortObject: {},
      totalCount: "",
      dailyLogCustomFields: [],
      dailyLogFields: [
        {
          dataField: "Image",
          caption: this.$t("common.image"),
          cellTemplate: "image-cell",
          allowFiltering: false,
          allowEditing: false,
          allowSorting: false,
          showInColumnChooser: true,
          visible: true,
          // alignment: "center",
          cssClass: "image-index",
          allowSearch: false,
          width: "80",
          minWidth: "80",
          allowReordering : false,
        },
        {
          dataField: "FirstName",
          caption: this.$t("common.firstName"),
          allowHeaderFiltering: false,
          visible: true,
          width: "auto",
          minWidth: "115",
          validationRules: [
            {
              type: "required",
              message: this.$t("common.firstName") + " " + this.$t("common.required"),
            },
            {
              type: "stringLength",
              max: 20,
              message: this.$t("common.validation.maximumLength20Characters"),
            },
          ],
        },
        {
          dataField: "LastName",
          caption: this.$t("common.lastName"),
          visible: true,
          allowHeaderFiltering: false,
          width: "auto",
          minWidth: "115",
          validationRules: [
            {
              type: "required",
              message: this.$t("common.lastName") + " " + this.$t("common.required"),
            },
            {
              type: "stringLength",
              max: 20,
              message: this.$t("common.validation.maximumLength20Characters"),
            },
          ],
        },
        {
          dataField: "UserType",
          caption: this.$t("common.userType"),
          allowEditing: false,
          visible: true,
          width: "auto",
          minWidth: "120",
          allowFiltering: false,
          allowHeaderFiltering: true,
          headerFilterDataSource: "userTypeHeaderFilter",
          // headerFilterGroupInterval: [["UserType"], ["UserType"]],
        },
        {
          dataField: "Status",
          caption: this.$t("common.status"),
          cellTemplate: "status-cell",
          allowEditing: false,
          visible: true,
          width: "auto",
          minWidth: "100",
          allowFiltering: false,
          allowHeaderFiltering: true,
          headerFilterDataSource: "statusHeaderFilter",
          lookupDataSource: "statusHeaderFilter",
          lookupDisplayExpr: "name",
          lookupValueExpr: "id",
        },
        {
          dataField: "CurrentJourneyStage",
          caption: this.$t("dashboard.grid.currentJourneyStage"),
          allowEditing: false,
          width: "auto",
          minWidth: "110",
          allowFiltering: false,
          allowHeaderFiltering: true,
          allowSorting: false,
          // minWidth: "200",
          cellTemplate: "journeyStage-cell",
          headerFilterDataSource: "journeyStageHeaderFilter",
          visible: false,
        },
        {
          dataField: "Reason",
          caption: this.$t("dashboard.grid.currentReason"),
          dataType: "string",
          width: "auto",
          minWidth: "100",
          allowHeaderFiltering: false,
          allowFiltering: false,
          allowEditing: false,
          allowSorting: false,
          visible: false,
        },
        {
          dataField: "ExpectedTime",
          width: "auto",
          minWidth: "120",
          caption: this.$t("dashboard.grid.expectedTime"),
          allowEditing: false,
          dataType: "datetime",
          format: "dd/MM/yyyy - hh:mm:ss a",
          selectedFilterOperation: "between",
          allowHeaderFiltering: false,
          allowFiltering: true,
          filterOperations: ["between"],
          visible: true,
        },
        {
          dataField: "ArrivalTime",
          width: "auto",
          minWidth: "120",
          caption: this.$t("dashboard.grid.arrivalTime"),
          allowEditing: false,
          dataType: "datetime",
          format: "dd/MM/yyyy - hh:mm:ss a",
          selectedFilterOperation: "between",
          visible: true,
          allowHeaderFiltering: false,
          allowFiltering: true,
          filterOperations: ["between"],
        },
        {
          dataField: "DepartureTime",
          caption: this.$t("dashboard.grid.departureTime"),
          width: "auto",
          minWidth: "120",
          allowEditing: false,
          dataType: "datetime",
          format: "dd/MM/yyyy - hh:mm:ss a",
          selectedFilterOperation: "between",
          allowHeaderFiltering: false,
          allowFiltering: true,
          filterOperations: ["between"],
          visible: true,
        },
        {
          dataField: "Site",
          width: "auto",
          minWidth: "100",
          caption: this.$t("common.site"),
          allowFiltering: false,
          allowHeaderFiltering: true,
          allowEditing: false,
          visible: true,
          cellTemplate: "site-cell",
          headerFilterGroupInterval: [["site"], ["area"]],
          headerFilterDataSource: "areaHeaderFilter",
        },
        {
          dataField: "visitNotes",
          caption: this.$t("dashboard.grid.visitNotes"),
          allowEditing: false,
          allowHeaderFiltering: false,
          width: "auto",
          minWidth: "100",
          cellTemplate: "visit-notes-cell",
          visible: false,
        },
        {
          dataField: "EmailAddress",
          caption: this.$t("common.emailAddress"),
          allowHeaderFiltering: false,
          width: "auto",
          minWidth: "100",
          cellTemplate: "default-template",
          validationRules: [
            {
              type: "pattern",
              pattern: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
              message: this.$t("common.notes.invalidEmail"),
            },
            {
              type: "custom",
              validationCallback: this.validateEmail,
              reevaluate: true,
              message: this.$t("common.notes.addEmailOrPhone"),
            },
            {
              type: "async",
              validationCallback: this.asyncValidation,
              message: this.$t("common.notes.emailAddressAlreadyExists"),
            },
          ],
          visible: false,
        },
        {
          dataField: "countryCode",
          caption: this.$t("dashboard.grid.countryCode"),
          allowHeaderFiltering: false,
          allowFiltering: false,
          visible: this.isEdit,
          showInColumnChooser: false,
          setCellValue: "resetPhone",
          lookupDataSource: "countryCodes",
          lookupDisplayExpr: "dial_code",
          lookupValueExpr: "finalCode",
          width: "200",
          validationRules: [
            {
              type: "custom",
              validationCallback: this.validateCountryCode,
              reevaluate: true,
              message: this.$t("dashboard.grid.countryCode") + " " + this.$t("common.required"),
            },
          ],
        },
        {
          dataField: "PhoneNumber",
          caption: this.$t("common.phoneNumber"),
          dataType: "number",
          alignment: "start",
          allowHeaderFiltering: false,
          width: "auto",
          minWidth: "100",
          cellTemplate: "default-template",
          validationRules: [
            {
              type: "custom",
              validationCallback: this.validatePhone,
              reevaluate: true,
              message: this.$t("common.phone") + " " + this.$t("common.required"),
            },
            {
              type: "async",
              validationCallback: this.asyncPhoneValidation,
              message: this.$t("common.notes.phoneNumberAlreadyExists"),
            },
          ],
          visible: false,
        },
        {
          dataField: "RFID",
          caption: this.$t("common.RFID"),
          allowHeaderFiltering: false,
          allowSorting: false,
          allowEditing: false,
          width: "auto",
          minWidth: "100",
          cellTemplate: "rfid-template",
          visible: false,
        },
        {
          dataField: "ID",
          caption: this.$t("common.id"),
          allowHeaderFiltering: false,
          allowEditing: false,
          width: "auto",
          minWidth: "100",
          visible: false,
        },
        {
          dataField: "Label",
          caption: this.$t("common.label"),
          allowEditing: false,
          allowHeaderFiltering: false,
          allowFiltering: true,
          visibleIndex: 18,
          width: "auto",
          minWidth: "100",
          calculateCellValue: this.calculateLabelValue,
          visible: false,
        },
      ],
      toggleHeaderFilter: [
        {
          text: "Yes",
          value: 1,
        },
        {
          text: "No",
          value: 0,
        },
      ],
      smileysToShow: [
        ["sad", "happy"],
        ["sad", "poker", "happy"],
        ["sad", "poker", "semi-happy", "happy"],
        ["sad", "semi-sad", "poker", "semi-happy", "happy"],
        ["sad", "semi-sad", "poker", "semi-happy", "happy", "smile"],
        [
          "hesitate",
          "sad",
          "semi-sad",
          "poker",
          "semi-happy",
          "happy",
          "smile",
        ],
        [
          "hesitate",
          "sad",
          "semi-sad",
          "poker",
          "semi-happy",
          "happy",
          "smile",
          "love",
        ],
        [
          "cry",
          "hesitate",
          "sad",
          "semi-sad",
          "poker",
          "semi-happy",
          "happy",
          "smile",
          "love",
        ],
        [
          "frown",
          "cry",
          "hesitate",
          "sad",
          "semi-sad",
          "poker",
          "semi-happy",
          "happy",
          "smile",
          "love",
        ],
      ],
      dataStore: [],
      buttonData: ["Excel", "CSV", "PDF"],
      hasMaskHeaderFilter: [
        {
          text: "Yes",
          value: ["hasMask", "contains", "Yes"],
        },
        {
          text: "No",
          value: ["hasMask", "contains", "No"],
        },
        {
          text: "Not Applicable",
          value: ["hasMask", "contains", "Not_Applicable"],
        },
      ],
      tempHeaderFilter: [
        {
          name: "<= 30",
          id: [0, 30],
        },
        {
          name: "30 - 34",
          id: [30, 34],
        },
        {
          name: "34 - 40",
          id: [34, 40],
        },
        {
          name: ">= 40",
          id: [40, 50],
        },
      ],
      vaccineHeaderFilter: [
        {
          name: "Vaccinated",
          id: "Vaccinated",
        },
        {
          name: "Not Applicable",
          id: "Not Applicable",
        },
        {
          name: "Negative PCR",
          id: "Negative PCR",
        },
        {
          name: "Positive PCR",
          id: "Positive PCR",
        },
        {
          name: "Unchecked",
          id: "Unchecked",
        },
        {
          name: "Expired",
          id: "Expired",
        },
        {
          name: "Not Supported",
          id: "Not Supported",
        },
      ],
      journeyStageHeaderFilter: [
        {
          text: this.$t('dashboard.grid.journeStages.compliancePending'),
          value: "compliance_pending",
        },
        {
          text: this.$t('dashboard.grid.journeStages.complianceFailed'),
          value: "compliance_failed",
        },
        {
          text: this.$t('dashboard.grid.journeStages.readyToSignIn'),
          value: "ready_to_sign_in",
        },
        {
          text: this.$t('dashboard.grid.journeStages.adminApproval'),
          value: "waiting_for_admin_approval",
        },
        {
          text: this.$t('dashboard.grid.journeStages.adminApprovalFailed'),
          value: "waiting_for_admin_approval_compliance_failed",
        },
        {
          text: this.$t('dashboard.grid.journeStages.rejectedByAdmin'),
          value: "rejected_by_admin",
        },
      ],
      userTypeHeaderFilter: [],
      statusHeaderFilter: [],
      inputTypeHeaderFilter: [],
      areaHeaderFilter: [],
      allowedOperations: ["contains"],
      selectedOperation: "contains", // default icon
      filterBy: {},
      orderBy: {},
      filterChanged: 0,
      dashboardColumns: dashboardColumns,
      hasMaskOptions: ["Yes", "No", "Not Applicable"],
      updatedInputTypes: [],
      vaccineOptions: [
      this.$t('dashboard.grid.vaccineOptions.vaccinated'),
      this.$t('dashboard.grid.vaccineOptions.notApplicable'),
      this.$t('dashboard.grid.vaccineOptions.negativePcr'),
      this.$t('dashboard.grid.vaccineOptions.positivePcr'),
      this.$t('dashboard.grid.vaccineOptions.unchecked'),
      this.$t('dashboard.grid.vaccineOptions.expired'),
      this.$t('dashboard.grid.vaccineOptions.notSupported'),
      ],
      vaccineDocument: false,
      selectedTempreture: "c",
      options: [
        { text: `°${this.$t("common.temperatureUnits.f")}`, value: "f" },
        { text: `°${this.$t("common.temperatureUnits.c")}`, value: "c" },
      ],
      dataGridRef,
      subGridRef,
      pdfTableHeaders: [],
      showClearAll: false,
      scanAttendanceCode: false,
      scanDocument: false,
      scanHost: false,
      scanReason: false,
      userDocument: false,
      selectedVisit : null,
    };
  },
  watch: {
    "getPrintBadgeFromQuickSignIn": {
      handler(value) {
        console.log("watch getPrintBadgeFromQuickSignIn", value);
        if (value.val) {
          this.printBadge(value.usersForPrint);
          this.setPrintBadgeFromQuickSignIn({val: false, usersForPrint: null});
        }
      },
      deep: true,
    },
    selectedTempreture(temp) {
      console.log("selectedTempreture", temp);
    },
    isSelectionMode(val) {
      console.log("watch isSelectionMode", val);
      if (val) {
        setTimeout(() => {
          console.log("timeout finish");
          const el = document.querySelectorAll(".dx-link-edit");
          if (el) {
            el?.forEach((e) => {
              e.classList.add("dx-state-disabled");
            });
          }
        }, 1000);
      } else {
        setTimeout(() => {
          const el = document.querySelectorAll(".dx-link-edit");
          if (el) {
            el?.forEach((e) => {
              e.classList.remove("dx-state-disabled");
            });
          }
        }, 1000);
      }
    },
    getRefreshGrid(val) {
      if (val) {
        this.dataGrid.refresh().then(() => {
          console.log("refreshed");
          this.$store.commit("preRegistration/setRefreshGrid", false);
        });
      }
    },

    getTableHeaders(value) {
      console.log("watch", value);
    },

    getExportProgessAppearance(value) {
      value && this.$bvModal.show("exportingProgress");
    },

    getInputTypes(getInputTypes) {
      this.updatedInputTypes = JSON.parse(JSON.stringify(getInputTypes));
      const objIndex = this.updatedInputTypes.findIndex(
        (obj) => obj.name == "face recognition"
      );
      this.updatedInputTypes[objIndex].name = "Facial Recognition";
    },

    getVisitApproved(approved) {
      if (approved) {
        this.$bvModal.hide("visit_modal");
        this.dataGrid.refresh().then(() => {
          console.log("refreshed");
        });
      }
    },

    getVisitRejected(rejected) {
      if (rejected) {
        this.$bvModal.hide("visit_modal");
        this.dataGrid.refresh().then(() => {
          console.log("refreshed");
        });
      }
    },

    getApproveVisit(value) {
      // console.log("getApproveVisit", value);
      if (value) {
        this.visitModalTitle =  this.$t('dashboard.grid.visitApprove.approveVisit');
      } else {
        this.visitModalTitle = this.manageVisit
          ? this.$t('dashboard.grid.visitApprove.manageVisit')
          : this.$t('dashboard.grid.visitApprove.fillInCompliance');
      }
    },

    getComplianceCreated(value) {
      // console.log("watch value", value);
      if (value && this.manageVisit)
        this.dataGrid.refresh().then(function () {
          console.log("refreshed");
        });
      console.log("this.visitData", this.visitData);
      this.fetchUserCompliance({
        user_id: this.visitData.user_id,
        user_type_id: this.visitData.user_type_id,
        area_id: this.visitData.area_id,
        visit_id: this.visitData.visit_id,
        entity_id: this.visitData.entity_id,
      });
    },

    getModalClosed(value) {
      if (value)
        this.dataGrid.refresh().then(function () {
          console.log("refreshed");
        });
    },

    getRejectVisit(value) {
      if (value) {
        this.visitModalTitle = this.$t("common.rejectVisitRequest");
      } else {
        this.visitModalTitle = this.manageVisit
          ? this.$t("common.manageVisit")
          : this.$t("common.fillInCompliance");
      }
    },
    getSocketDataToRefreshGrid(data) {
      console.log("Socket data received:", data);

      if (data && data.id) {
        const dataSource = this.dataGrid.getDataSource();
        const store = dataSource.store();
        const items = dataSource.items();

        // Check if the row already exists
        const rowIndex = items.findIndex(row => row.id === data.id);

        if (rowIndex !== -1) {
          // ✅ Update existing row
          store.update(data.id, data).then(() => {
            console.log("Updated existing row:", data.id);
            dataSource.reload();
          });
        } else {
          // ✅ Add new row if it doesn't exist
          store.insert(data).then(() => {
            console.log("Added new row:", data.id);
            dataSource.reload();
          });
        }

        // ✅ Ensure changes are reflected without full refresh
        this.dataGrid.refresh(true);
      } else {
        console.warn("Invalid data received:", data);
      }
    },
  },
  computed: {
    ...mapGetters("i18N", ["getLanguage"]),
    ...mapGetters("dailyLogbook", [
      "getAreas",
      "getUserTypes",
      "getInputTypes",
    ]),
    ...mapGetters("grid", [
      "getTableHeaders",
      "getTableFilters",
      "getFilterValues",
      "getExportProgessAppearance",
    ]),
    ...mapGetters("modal", ["getModalData"]),
    ...mapGetters("compliance", [
      "getComplianceList",
      "getComplianceCreated",
      "getModalClosed",
    ]),
    ...mapGetters("authfack", [
      "currentEntity",
      "userDetails",
      "getUserRole",
      "getSocketDataToRefreshGrid",
    ]),
    ...mapGetters("emergency", [
      "getActiveSessionsCount",
    ]),
    ...mapGetters("preRegistration", [
      "getVisitApproved",
      "getVisitRejected",
      "getApproveVisit",
      "getRejectVisit",
      "getRefreshGrid",
    ]),
    ...mapGetters("dailyLogbook", ["getPrintBadgeFromQuickSignIn"]),
    // canEdit() {
    //   // console.log("isSelectionMode", this.isSelectionMode, this.selectedRows);
    //   return !this.selectedRows.length;
    // },
    // selectedRowKeys_() {
    //   return this.selectedRowsData.map((user) => {
    //     return { user_id: user?.user?.id, visit_id: user.visit_id };
    //   });
    // },
    checkDate() {
      if (
        this.dateRangeLocal.length > 0 &&
        this.dateRangeLocal[0] ==
        moment
          .utc(new Date(Date.now()))
          .tz(moment.tz.guess())
          .format("YYYY-MM-DD") &&
        this.dateRangeLocal[1] ==
        moment
          .utc(new Date(Date.now()))
          .tz(moment.tz.guess())
          .format("YYYY-MM-DD")
      )
        return false;
      return true;
    },
    userEmail() {
      return this.userDetails && this.userDetails.email;
    },
    dailyLogGridColumns() {
      const fields = this.dailyLogFields.map((field) => {
        let column = {
          dataField: field.dataField,
          caption: field.caption,
          minWidth: field.minWidth,
          width: field.width,
          allowFiltering: field.allowFiltering,
          allowEditing: field.allowEditing,
          showInColumnChooser: field.showInColumnChooser,
          alignment: field.alignment,
          cssClass: field.cssClass,
          allowExporting: field.allowExporting,
          allowReordering : field.allowReordering,
          dataType: field.dataType,
          format: field.format,
          setCellValue: field.setCellValue,
          visible:
            field.dataField == "countryCode"
              ? this.isEdit
                ? true
                : false
              : this.getTableHeaders &&
                this.getTableHeaders.columns &&
                this.getTableHeaders.columns.find(
                  (item) => item.dataField == field.dataField
                ) &&
                (this.getTableHeaders.columns.find(
                  (item) => item.dataField == field.dataField
                ).visible ||
                  this.getTableHeaders.columns.find(
                    (item) => item.dataField == field.dataField
                  ).visible == false)
              ? this.getTableHeaders.columns.find(
                  (item) => item.dataField == field.dataField
                ).visible
              : field.dataField == "currentReason" && this.scanReason
              ? true
              : (field.dataField == "ID" || field.dataField == "CurrentJourneyStage"
                  || field.dataField == "Reason" || field.dataField == "visitNotes" ||
                  field.dataField == "EmailAddress" || field.dataField == "PhoneNumber" ||
                  field.dataField == "RFID" || field.dataField == "Label")
              ? false
              : true,

          filterValue: this.getFilterValue(field),

          filterValues:
            this.getTableHeaders &&
            this.getTableHeaders.columns &&
            this.getTableHeaders.columns.find(
              (item) => item.dataField == field.dataField
            ) &&
            this.getTableHeaders.columns.find(
              (item) => item.dataField == field.dataField
            ).filterValues,

            filterType:
            this.getTableHeaders &&
            this.getTableHeaders.columns &&
            this.getTableHeaders.columns.find(
              (item) => item.dataField == field.dataField
            ) &&
            this.getTableHeaders.columns.find(
              (item) => item.dataField == field.dataField
            ).filterType,

          visibleIndex:
            this.getTableHeaders &&
            this.getTableHeaders.columns &&
            this.getTableHeaders.columns.find(
              (item) => item.dataField == field.dataField
            ) &&
            this.getTableHeaders.columns.find(
              (item) => item.dataField == field.dataField
            ).visibleIndex
              ? this.getTableHeaders &&
                this.getTableHeaders.columns &&
                this.getTableHeaders.columns.find(
                  (item) => item.dataField == field.dataField
                ) &&
                this.getTableHeaders.columns.find(
                  (item) => item.dataField == field.dataField
                ).visibleIndex
              : field.visibleIndex,

          sortOrder:
            this.getTableHeaders &&
            this.getTableHeaders.columns &&
            this.getTableHeaders.columns.find(
              (item) => item.dataField == field.dataField
            ) &&
            this.getTableHeaders.columns.find(
              (item) => item.dataField == field.dataField
            ).sortOrder,

          sortIndex:
            this.getTableHeaders &&
            this.getTableHeaders.columns &&
            this.getTableHeaders.columns.find(
              (item) => item.dataField == field.dataField
            ) &&
            this.getTableHeaders.columns.find(
              (item) => item.dataField == field.dataField
            ).sortIndex,

          allowHeaderFiltering: field.allowHeaderFiltering,
          filterOperations: field.filterOperations
            ? ["between"]
            : this.allowedOperations,
          selectedFilterOperation: field.selectedFilterOperation
            ? field.selectedFilterOperation
            : "",
          allowSorting: field.allowSorting,
          calculateCellValue: field.calculateCellValue,
          validationRules: field.validationRules,
        };
        if (field.cellTemplate) {
          column.cellTemplate = field.cellTemplate;
        }

        if (field.headerFilterDataSource) {
          column.headerFilter = {
            dataSource: this[field.headerFilterDataSource],
            groupInterval: field.headerFilterGroupInterval,
          };
        }

        if (field.lookupDataSource) {
          column.lookup = {
            dataSource: this[field.lookupDataSource],
            displayExpr: field.lookupDisplayExpr,
            valueExpr: field.lookupValueExpr,
          };
        }
        // console.log('column', column);
        return column;
      });

      this.dailyLogCustomFields.forEach((field) => {
        let obj = {
          dataField: `Data.customFields.${field.id}`,
          caption:
            field.type == "ratingScale" &&
            (field.metadata[0].show_as == "stars" ||
              field.metadata[0].show_as == "labels")
              ? `${field.name} (Out of ${field.metadata[0].scale_count})`
              : field.name,
          allowEditing: false,
          allowFiltering:
            !field.type == "ratingScale" ||
            (field.type == "ratingScale" &&
              (field.metadata[0].show_as == "stars" ||
                field.metadata[0].show_as == "labels")),
          showInColumnChooser: true,
          allowExporting: false,
          allowHeaderFiltering:
            field.type == "ratingScale" || field.type == "toggleButton",
          filterOperations: this.allowedOperations,
          allowSorting: false,
          alignment: "start",
          width: "auto",
          minWidth: "100",
          visible:
            this.getTableHeaders &&
            this.getTableHeaders.columns?.find(
              (item) => item.dataField == `Data.customFields.${field.id}`
            ) &&
            (this.getTableHeaders.columns?.find(
              (item) => item.dataField == `Data.customFields.${field.id}`
            ).visible ||
              this.getTableHeaders.columns?.find(
                (item) => item.dataField == `Data.customFields.${field.id}`
              ).visible == false)
              ? this.getTableHeaders.columns?.find(
                  (item) => item.dataField == `Data.customFields.${field.id}`
                ).visible
              : true,

          filterValue:
            this.getTableHeaders &&
            this.getTableHeaders.columns?.find(
              (item) => item.dataField == `Data.customFields.${field.id}`
            ) &&
            this.getTableHeaders.columns?.find(
              (item) => item.dataField == `Data.customFields.${field.id}`
            ).filterValue,

          filterValues:
            this.getTableHeaders &&
            this.getTableHeaders.columns?.find(
              (item) => item.dataField == `Data.customFields.${field.id}`
            ) &&
            this.getTableHeaders.columns?.find(
              (item) => item.dataField == `Data.customFields.${field.id}`
            ).filterValues,

            filterType:
            this.getTableHeaders &&
            this.getTableHeaders.columns?.find(
              (item) => item.dataField == `Data.customFields.${field.id}`
            ) &&
            this.getTableHeaders.columns?.find(
              (item) => item.dataField == `Data.customFields.${field.id}`
            ).filterType,

          visibleIndex:
            this.getTableHeaders &&
            this.getTableHeaders.columns?.find(
              (item) => item.dataField == `Data.customFields.${field.id}`
            ) &&
            this.getTableHeaders.columns?.find(
              (item) => item.dataField == `Data.customFields.${field.id}`
            ).visibleIndex,

          sortOrder:
            this.getTableHeaders &&
            this.getTableHeaders.columns?.find(
              (item) => item.dataField == `Data.customFields.${field.id}`
            ) &&
            this.getTableHeaders.columns?.find(
              (item) => item.dataField == `Data.customFields.${field.id}`
            ).sortOrder,

          sortIndex:
            this.getTableHeaders &&
            this.getTableHeaders.columns?.find(
              (item) => item.dataField == `Data.customFields.${field.id}`
            ) &&
            this.getTableHeaders.columns?.find(
              (item) => item.dataField == `Data.customFields.${field.id}`
            ).sortIndex,
        };

        if (field.type === "date") obj.cellTemplate = "date-template";
        else if (field.type === "toggleButton") {
          obj.cellTemplate = "toggle-template";
          obj.headerFilter = {
            dataSource: this.toggleHeaderFilter,
          };
        } else if (field.type === "ratingScale") {
          let ratingHeaderFilter = [];
          if (field.metadata[0].show_as !== "smileys") {
            for (let i = 0; i < field.metadata[0].scale_count; i++) {
              ratingHeaderFilter.push({
                text: (i + 1).toString(),
                value: (i + 1).toString(),
              });
            }
          } else {
            ratingHeaderFilter = [
              { text: "Bad", value: 1 },
              { text: "Poor", value: 2 },
              { text: "OK", value: 3 },
              { text: "Good", value: 4 },
              { text: "Great", value: 5 },
            ];
          }
          obj.headerFilter = {
            dataSource: ratingHeaderFilter,
          };
          obj.cellTemplate = `${field.metadata[0].show_as}-template`;
          obj.cssClass =
            field.metadata[0].show_as + field.metadata[0].scale_count;
        } else if (field.type == "checkboxes") {
          obj.cellTemplate = "checkboxes-template";
        } else obj.cellTemplate = "dailyLogCustomField-template";
        fields.push(obj);
      });

      fields.push(
        {
          dataField: "UserData",
          caption: this.$t("dashboard.grid.userData"),
          type: "buttons",
          allowFiltering: false,
          allowExporting: false,
          allowEditing: false,
          visible: !this.showUserData
            ? false
            : this.getTableHeaders &&
              this.getTableHeaders.columns &&
              this.getTableHeaders.columns.find(
                (item) => item.dataField == "UserData"
              ) &&
              (this.getTableHeaders.columns.find(
                (item) => item.dataField == "UserData"
              ).visible ||
                this.getTableHeaders.columns.find(
                  (item) => item.dataField == "UserData"
                ).visible == false)
            ? this.getTableHeaders.columns.find(
                (item) => item.dataField == "UserData"
              ).visible
            : true,

          showInColumnChooser: this.showUserData,
          width: "164",
          cellTemplate: "user-edit-template",
        },
        {
          dataField: "Actions",
          caption: this.$t("common.grid.actions"),
          minWidth: "420",
          allowFiltering: false,
          allowExporting: false,
          allowEditing: false,
          visible:
            this.getTableHeaders &&
            this.getTableHeaders.columns &&
            this.getTableHeaders.columns.find(
              (item) => item.dataField == "Actions"
            ) &&
            (this.getTableHeaders.columns.find(
              (item) => item.dataField == "Actions"
            ).visible ||
              this.getTableHeaders.columns.find(
                (item) => item.dataField == "Actions"
              ).visible == false)
              ? this.getTableHeaders.columns.find(
                  (item) => item.dataField == "Actions"
                ).visible
              : true,
          cssClass: "select-actions select-actionsDAsh",
          cellTemplate: "action-cell",
        },
      );

      // console.log('fields', fields);
      return fields;
    },
    // getCurrentDate() {
    //   return [moment().format("YYYY-MM-DD"), moment().format("YYYY-MM-DD")];
    // },
    dataGrid() {
      return this.$refs[this.dataGridRef].instance;
    },
    subGrid() {
      return this.focusedComponent
        ? this.focusedComponent
        : this.$refs[this.subGridRef].instance;
    },
    // availableHours: function () {
    //   let todayDate = new Date(
    //     new Date().toLocaleString("en-US", {
    //       timeZone: this.preRegTimeZone,
    //     })
    //   );
    //   let dateString = todayDate.toISOString().slice(0, 10);
    //   this.dateValue?.setHours(12);
    //   if (this.dateValue?.toISOString().slice(0, 10) === dateString) {
    //     let cTime = todayDate.getHours();
    //     const arr = this.range(cTime, 23);
    //     const hrsArr = [];
    //     arr.map((hours) => {
    //       if (!hrsArr.includes(hours % 12))
    //         hrsArr.push(hours % 12 ? hours % 12 : 0);
    //     });
    //     return hrsArr;
    //   }
    //   return this.range(0, 23);
    // },
    // availableMinuts: function () {
    //   let todayDate = new Date(
    //     new Date().toLocaleString("en-US", {
    //       timeZone: this.preRegTimeZone,
    //     })
    //   );
    //   let dateString = todayDate.toISOString().slice(0, 10);
    //   if (this.dateValue?.toISOString().slice(0, 10) === dateString) {
    //     let cTime = todayDate.getHours();
    //     let selectedHour = this.timeValue?.getHours();
    //     if (cTime === selectedHour) {
    //       return this.range(todayDate.getMinutes() + 5, 59);
    //     }
    //   }
    //   return this.range(0, 59);
    // },
  },
  created() {
    document.addEventListener("mousedown", (e) => {
      // console.log('mousedown');
      if (e.path) {
        // console.log("path", e.path);
        let isColumnChooser = false;
        for (let i = 0; i < e.path.length; i++) {
          if (typeof e.path[i].matches == "function") {
            if (e.path[i].matches(".dx-overlay-content")) {
              isColumnChooser = true;
            }
          }
        }
        if (!isColumnChooser) this.dataGrid.hideColumnChooser();
      }
    });

    this.getInputTypes.map((inputType) => {
      this.inputTypeHeaderFilter.push({
        text: inputType.name,
        value: ["InputType", "contains", inputType.id],
      });
    });
  },
  sockets: {
    update(data) {
      if (data.scansUpdated) {
        console.log("update row dashboard", data);
        this.hideLoader = true;
        this.dataGrid.refresh().then(() => {
          console.log("refreshed");
          setTimeout(() => {
            this.hideLoader = false;
          }, 500);
        });
      }
    },
    updateUserType(data) {
      console.log("updateUserType row dashboard", data);
      this.hideLoader = true;
      this.dataGrid.refresh().then(() => {
        console.log("refreshed");
        setTimeout(() => {
          this.hideLoader = false;
        }, 500);
      });
    },
  },
  methods: {
    ...mapActions("visit", ["fetchUsersByEmailOrPhone"]),
    ...mapActions("dashboard", ["fetchDashboardData"]),
    ...mapActions("dailyLogbook", ["resetDashboardData"]),
    ...mapActions("grid", [
      "onTableHeader",
      "updateTableHeaders",
      "createTableHeaders",
      "resetTableHeaders",
      "resetFilterValues",
      "resetSelectedRows",
      "exportJobBE",
      "setPrintBadgeFromQuickSignIn"
    ]),
    ...mapActions("modal", ["onResetModal", "setData"]),
    ...mapActions("compliance", [
      "fetchUserCompliance",
      "selectComplianceCreated",
      "resendUserCompliance",
    ]),
    ...mapActions("users", [
      "updateUserAction",
      "addUserWalkin",
    ]),
    ...mapActions("preRegistration", [
      "setVisitApproved",
      "setVisitRejected",
      "setApproveVisit",
      "setRejectVisit",
      "editExpectedVisit",
      "deleteExpectedVisit",
    ]),
    ...mapActions("sites", ["fetchAreaDocument"]),
    setUpdateScroll() {
      this.needUpdateScrollPosition = true;
    },
    refreshGrid() {
      this.dataGrid.refresh();
    },
    setColumnAppearance() {
      this.scanAttendanceCode = this.dashboardData.scanAttendanceCode;
      this.scanDocument = this.dashboardData.scanDocument;
      this.scanHost = this.dashboardData.scanHost;
      this.scanReason = this.dashboardData.scanReason;
      this.userDocument = this.dashboardData.userDocument;
    },
    focusChanged(e) {
      if (e.rowIndex === -1) return;
      if (this.focusedComponent && this.focusedComponent != e.component) {
        this.focusedComponent.option("focusedRowIndex", -1);
      }
      this.focusedComponent = e.component;
    },
    editRow(data) {
      console.log("editRow", data);
      // Use the DevExtreme DataGrid's API to start editing the row
      data.component.editRow(data.rowIndex);
    },
    startEdit(data) {
      // console.log('startEdit', data)
      data.component.editRow(data.rowIndex);
      data.component.option("focusedRowIndex", data.rowIndex);
      data.isEditing = true;
      Vue.set(data, "isEditing", true);
      this.editingVisitId = data.data ? data.data.visit_id : data.row ? data.row.data?.visit_id : null;
      console.log("editRow", data);
    },
    saveRow(data) {
      this.dataGrid.saveEditData(data.key);
    },
    cancelEdit(data) {
      this.dataGrid.cancelEditData(data.key);
      this.editingVisitId = null;
    },
    onInitialized(e) {
      e.component.option("stateStoring", { ignoreColumnOptionNames: [] });
    },

    getFilterValue(field) {
      if (this.getTableHeaders && field.dataField == "ArrivalTime") {
        const atColumn = this.getTableHeaders.columns?.find(
          (column) => column.dataField == "ArrivalTime"
        );
        if (
          atColumn &&
          atColumn.filterValue &&
          atColumn.filterValue.length > 0
        ) {
          atColumn.filterValue = atColumn.filterValue.map((val) => {
            return val ? new Date(val) : null;
          });
        }
        return atColumn?.filterValue;
      } else if (this.getTableHeaders && field.dataField == "DepartureTime") {
        const atColumn = this.getTableHeaders.columns?.find(
          (column) => column.dataField == "DepartureTime"
        );
        if (
          atColumn &&
          atColumn.filterValue &&
          atColumn.filterValue.length > 0
        ) {
          atColumn.filterValue = atColumn.filterValue.map((val) => {
            return val ? new Date(val) : null;
          });
        }
        return atColumn?.filterValue;
      } else if (this.getTableHeaders && field.dataField == "ExpectedTime") {
        const atColumn = this.getTableHeaders.columns?.find(
          (column) => column.dataField == "ExpectedTime"
        );
        if (
          atColumn &&
          atColumn.filterValue &&
          atColumn.filterValue.length > 0
        ) {
          atColumn.filterValue = atColumn.filterValue.map((val) => {
            return val ? new Date(val) : null;
          });
        }
        return atColumn?.filterValue;
      }
      return (
        this.getTableHeaders &&
        this.getTableHeaders.columns?.find(
          (item) => item.dataField == field.dataField
        ) &&
        this.getTableHeaders.columns.find(
          (item) => item.dataField == field.dataField
        ).filterValue
      );
    },
    async onSelectionChanged(e) {
      e.component.cancelEditData();
      this.selectedRowsData = e.selectedRowsData
        ?.filter(this.checkIfSelectable)
        ?.map((user) => {
          console.log({ user });
          //Check if there is any expected scan in scans list
          //Note: if user answered the compliances withing grace period ,the expected scan will not be the first scan on the list
          const isExpectedScanExistIndex = user.scans?.findIndex(
            (scan) => scan?.scan_data_type?.id == "6"
          );

          //check if user has expected visit on same day
          const isExpectedToday =
            user.ExpectedTime && moment(user.ExpectedTime).isValid()
              ? user.ExpectedTime.isSame(new Date(), "day")
              : null;
          let expectedAreaId = "",
            expectedUserTypeId = "",
            expectedSiteId = "";

          const isSignedOut = user.scan_data_type_id == "3";
          const signedOutAreaId = isSignedOut && user.area_id;
          const signedOutUserTypeId = isSignedOut && user.user_type_id;

          if (isExpectedScanExistIndex >= 0 && isExpectedToday) {
            expectedAreaId = user?.area_id;
            expectedSiteId = user?.site_id;
            expectedUserTypeId =
              user.scans[isExpectedScanExistIndex].Data.user_type_id;
          }
          return {
            expectedUserTypeId: expectedUserTypeId ?? null,
            expectedAreaId: expectedAreaId ?? null,
            expectedSiteId: expectedSiteId ?? null,
            signedOutAreaId: signedOutAreaId ?? null,
            signedOutUserTypeId: signedOutUserTypeId ?? null,
            id: user?.user_id,
            user_type_id: user?.user?.type_id,
            visit_id: user.visit_id,
          };
        });
      this.noOfSelectedRows = this.selectedRowsData?.length;
      this.isSelectionMode = this.selectedRowsData?.length ? true : false;
      this.isSelectAll(e.component);
      this.showCommonActions(e.selectedRowsData);
    },
    showCommonActions(data) {
      let rows = JSON.parse(JSON.stringify(data));
      // console.log("rows", rows);
      if (rows.length == 0) {
        this.commonActions = [];
        return;
      }
      if (rows.find((item) => item.CurrentJourneyStageID == "-")) {
        this.commonActions = ["Sign in/out"];
        return;
      }
      let expectedVisit;
      let expectedScan;
      let rejectedScan;
      let compliancePending;
      let complianceFailed;
      let adminApproval;
      let adminApprovalCompFailed;
      let readySignIn;
      let rejectedByAdmin;
      let preRegAllowed;
      let preRegApprovalReq;

      const sameUserType = rows.every(
        (row, _, arr) => row.user_type_id === arr[0].user_type_id
      );

      const sameSite = rows.every(
        (row, _, arr) => row.site_id === arr[0].site_id
      );

      let allSiteAndArea = [];

      rows.map((row) => {
        if (row.Data.isExpectedScanExist) {
          allSiteAndArea.push({
            areaId: row.Data.ExpectedScanAreaId,
            siteId: row.Data.ExpectedScanSiteId,
          });
        }
        if (row.Data.isRejectedScanExist) {
          allSiteAndArea.push({
            areaId: row.Data.RejectedScanAreaId,
            siteId: row.Data.RejectedScanSiteId,
          });
        }
      });

      const sameSiteAndArea = allSiteAndArea.every(
        (row, _, arr) =>
          row.siteId === arr[0].siteId && row.areaId === arr[0].areaId
      );

      rows.map((row) => {
        expectedVisit = false;
        expectedScan = false;
        rejectedScan = false;
        compliancePending = false;
        complianceFailed = false;
        adminApproval = false;
        adminApprovalCompFailed = false;
        readySignIn = false;
        rejectedByAdmin = false;
        preRegAllowed = false;
        preRegApprovalReq = false;

        if (row.Data.scan_data_type_id == 6) {
          expectedVisit = true;
        }
        if (row.Data.isExpectedScanExist) {
          expectedScan = true;
        }
        if (row.Data.isRejectedScanExist) {
          rejectedScan = true;
        }

        if (row.CurrentJourneyStageID == "compliance_pending") {
          compliancePending = true;
        } else if (row.CurrentJourneyStageID == "compliance_failed") {
          complianceFailed = true;
        } else if (row.CurrentJourneyStageID == "waiting_for_admin_approval") {
          adminApproval = true;
        } else if ( row.CurrentJourneyStageID == "waiting_for_admin_approval_compliance_failed") {
          adminApprovalCompFailed = true;
        } else if (row.CurrentJourneyStageID == "ready_to_sign_in") {
          readySignIn = true;
        } else if (row.CurrentJourneyStageID == "rejected_by_admin") {
          rejectedByAdmin = true;
        }
        if (
          row.pre_registration_method == "REGISTRATION_ALLOWED" ||
          row.pre_registration_method == "PRE_REGISTERED_ONLY"
        ) {
          preRegAllowed = true;
        } else if (
          row.pre_registration_method ==
          "PRE_REGISTRATION_WITH_APPROVAL_REQUIRED"
        ) {
          preRegApprovalReq = true;
        }

        if (expectedVisit && expectedScan) {
          if (compliancePending && preRegAllowed) {
            row.actions = ["Delete", "Sign in/out"];
            if (sameSite) row.actions.push("Edit");
          } else if (compliancePending && preRegApprovalReq) {
            row.actions = ["Delete", "Sign in/out"];
            if (sameSite) row.actions.push("Edit");
            if (sameUserType && sameSiteAndArea)
              row.actions.push("Manage visit");
          } else if (complianceFailed && preRegAllowed) {
            row.actions = ["Delete", "Resend compliance", "Sign in/out"];
            if (sameSite) row.actions.push("Edit");
          } else if (complianceFailed && preRegApprovalReq) {
            row.actions = ["Delete", "Resend compliance", "Sign in/out"];
            if (sameSite) row.actions.push("Edit");
            if (sameUserType && sameSiteAndArea)
              row.actions.push("Manage visit");
          } else if (adminApproval && preRegApprovalReq) {
            row.actions = ["Delete", "Sign in/out"];
            if (sameSite) row.actions.push("Edit");
            if (sameUserType && sameSiteAndArea)
              row.actions.push("Manage visit");
          } else if (adminApproval && preRegAllowed) {
            row.actions = [];
          } else if (adminApprovalCompFailed && preRegApprovalReq) {
            row.actions = ["Delete", "Resend compliance", "Sign in/out"];
            if (sameSite) row.actions.push("Edit");
            if (sameUserType && sameSiteAndArea)
              row.actions.push("Manage visit");
          } else if (adminApprovalCompFailed && preRegAllowed) {
            row.actions = [];
          } else if (readySignIn && preRegAllowed) {
            row.actions = ["Delete", "Sign in/out"];
            if (sameSite) row.actions.push("Edit");
          } else if (readySignIn && preRegApprovalReq) {
            row.actions = ["Delete", "Sign in/out"];
            if (sameSite) row.actions.push("Edit");
            if (sameUserType && sameSiteAndArea) row.actions.push("Reject");
          }
        } else if (expectedScan) {
          if (compliancePending && preRegAllowed) {
            row.actions = ["Sign in/out"];
          } else if (compliancePending && preRegApprovalReq) {
            row.actions = ["Sign in/out"];
            if (sameUserType && sameSiteAndArea)
              row.actions.push("Manage visit");
          } else if (complianceFailed && preRegAllowed) {
            row.actions = ["Resend compliance", "Sign in/out"];
          } else if (complianceFailed && preRegApprovalReq) {
            row.actions = ["Resend compliance", "Sign in/out"];
            if (sameUserType && sameSiteAndArea)
              row.actions.push("Manage visit");
          } else if (adminApproval && preRegApprovalReq) {
            row.actions = ["Sign in/out"];
            if (sameUserType && sameSiteAndArea)
              row.actions.push("Manage visit");
          } else if (adminApproval && preRegAllowed) {
            row.actions = [];
          } else if (adminApprovalCompFailed && preRegApprovalReq) {
            row.actions = ["Resend compliance", "Sign in/out"];
            if (sameUserType && sameSiteAndArea)
              row.actions.push("Manage visit");
          } else if (adminApprovalCompFailed && preRegAllowed) {
            row.actions = [];
          } else if (readySignIn && preRegAllowed) {
            row.actions = ["Sign in/out"];
          } else if (readySignIn && preRegApprovalReq) {
            row.actions = ["Sign in/out"];
            if (sameUserType && sameSiteAndArea) row.actions.push("Reject");
          }
        } else if (rejectedScan) {
          if (rejectedByAdmin && preRegApprovalReq) {
            row.actions = ["Sign in/out"];
            if (sameUserType && sameSiteAndArea) row.actions.push("Approve");
          }
        }
      });

      if (rows.length > 0) {
        const actionsArray = rows.map((row) => {
          return row.actions;
        });

        this.commonActions = actionsArray.reduce((prev, curr) =>
          prev.filter((action) => curr?.includes(action))
        );
        console.log("commonActions", this.commonActions);
      }
    },
    checkIfSelectable(item) {
      return (
        item?.is_active == "1" &&
        !item.isDeletedUser &&
        !item.user_id?.includes("undefined")
      );
    },
    isSelectAll(dataGrid) {
      const currentVisibleRows = dataGrid?.getVisibleRows();
      let selectableRows = currentVisibleRows?.filter((item) =>
        this.checkIfSelectable(item.data)
      );
      selectableRows = selectableRows.filter(
        (item) => !this.disableCheckbox(item.data)
      );

      let selectedRowKeys = dataGrid.option("selectedRowKeys");

      let visibleSelectedCount = 0;
      selectedRowKeys?.forEach((row) => {
        const indx = selectableRows?.findIndex(
          (visibleRow) => visibleRow.data.visit_id == row.visit_id
        );
        if (indx >= 0) visibleSelectedCount++;
      });

      const deselectableRows = currentVisibleRows
        ?.filter((row) => row?.data?.is_active == "0")
        ?.map((row) => {
          return {
            visit_id: row.data?.visit_id,
            user_id: row?.data?.user_id,
          };
        });

      deselectableRows.concat(
        currentVisibleRows.filter((item) => this.disableCheckbox(item.data))
      );

      if (visibleSelectedCount == 0) dataGrid?.deselectAll();
      else if (visibleSelectedCount == selectableRows?.length)
        dataGrid.selectAll();
      else if (deselectableRows?.length)
        dataGrid?.deselectRows(deselectableRows);
      //Get previously selected row count on the current page only
      // const previousSelectedRowKeysOnCurrentPage = selectableRows?.filter(row=>{
      //   const indx = this.previousSelectedRowKeys?.findIndex(item=> item.visit_id == row.data.visit_id )
      //   return indx >= 0
      // })

      // if(previousSelectedRowKeysOnCurrentPage?.length >= visibleSelectedCount ) return 'deselectAll'
      // else if(previousSelectedRowKeysOnCurrentPage?.length < visibleSelectedCount) return 'selectAll'
    },
    async resendCompliance() {
      this.resendLoading = true;
      const { visit_id } = this;
      await this.resendUserCompliance({ visit_id });
      this.$bvModal.hide("reloadCompliance");
      this.resendLoading = false;
      await this.dataGrid.refresh();
    },
    setVisitData(value) {
      // console.log('setVisitData', value);
      this.visitData = value;
    },
    checkInSubmit(val) {
      console.log("checkInSubmit", val);
      val && this.dataGrid.refresh();
    },
    printBadge(val) {
      console.log("printBadgeeee", val);
      this.usersForPrint = val;
      setTimeout(() => {
        this.printPage();
      }, 500);
    },
    printPage() {
      const printContent = document.getElementById("multi-print-area").innerHTML;
      const printWindow = window.open("", "", "width=800,height=600");

      const html = `
        <html>
          <head>
            <link href="https://fonts.googleapis.com/css2?family=Lato&display=swap" rel="stylesheet" onload="this.loaded=true">
            <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.13.0/css/all.min.css" onload="this.loaded=true">
            <style>
              ${this.getPrintStyles()}
            </style>
            <scr` + `ipt>
              function waitForResources() {
                const links = document.querySelectorAll('link[rel="stylesheet"]');
                const allLoaded = Array.from(links).every(l => l.loaded);
                if (allLoaded) {
                  window.print();
                  window.close();
                } else {
                  setTimeout(waitForResources, 50);
                }
              }
            </scr` + `ipt>
          </head>
          <body onload="waitForResources()">
            ${printContent}
          </body>
        </html>
      `;

      printWindow.document.write(html);
      printWindow.document.close();
    },
    getPrintStyles() {
        return `
          @media print {
            body {
              zoom: 2; /* Scale content 2x (200%) */
            }
          }
          body {
            font-family: 'Lato';
          }
          .multi-print-page {
            width: 255px;
            color: #000000;
            position: relative;
            padding: 5px 10px;
            padding-bottom: 0;
            text-align: start;
            min-height: 48vh;
          }
          .multi-print-text {
            font-size: 9px;
            font-weight: 700;
            position: relative;
            z-index: 1;
            line-height: 1.2;
          }
          .multi-watermark {
            position: absolute;
            font-size: 48px;
            color: rgba(0, 0, 0, 0.1);
            z-index: 0;
            pointer-events: none;
            white-space: nowrap;
          }
          .logo-watermark {
            top: 0;
            inset-inline-start: 20%;
          }
          .entity-watermark {
            top: 12%;
            inset-inline-start: 50%;
            transform: translate(-50%, -50%) rotate(-45deg);
          }
          
          .img-watermark {
            opacity: 15%;
            max-height: 121px;
            max-width: 78px;
            width: auto;
          }
          
          .qr-border {
            border: 3px solid black;
            padding: 3px;
            border-radius: 5px;
            max-width: 54px;
            width: 54px;
            height: 54px;
            position: relative;
            z-index: 1;
          }
          .qr-img {
            max-width: 53px;
            width: 53px;
            height: 53px;
          }
          .user-img {
            border-radius: 5px;
            width: 64px !important;
            height: 64px !important;
          }

          .sections {
            display: flex;
            flex-direction: column;
            gap: 7px;
          }

          .section1 {
              display: flex;
          }

          .section1.noPhotoNoQr {
            justify-content: center;
          }

          .section1.withPhotoQr, .section1.qrOnly {
              justify-content: space-between;
          }

          .section1.photoOnly {
              gap: 8px
          }

          .section1-text.noPhotoNoQr, .section1-text.withPhotoQr {
            text-align: center;
          }

          .section1-text,
          .section2 {
            display: flex;
            flex-direction: column;
            .multi-print-text-without-fields {
              margin-bottom: 8px;
            }
            .multi-print-text-with-fields {
              margin-bottom: 8px;
            }
          }

          .section1-text {
            height: 64px;
            justify-content: space-between;
          }

          .section2 {
            min-height: 60px;
            justify-content: center;
          }

          .section2.noPhotoNoQr {
              text-align: center;
          }

          .section3 {
              text-align: center;
              gap: 11px;
              display: flex;
              flex-direction: column;
          }

          .nowrap {
            white-space: nowrap;
          }

          .badge-separator {
            border-top: 0.75px solid #000000;
            margin-bottom: 8px;
          }

          .badge-section {
              height: 30px;
          }

          .badges {
              display: flex;
              flex-wrap: wrap;
              font-size: 9px;
              align-items: center;
            }

          .badge-block {
              display: flex;
              align-items: center;
              gap: 3px;
              flex: 0 0 50%;
          }

          .badge-icon {
            width: 15px;
            height: 15px;
            background: #000000;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 2px;
          }
        `;
      },
    pickDate(e) {
      this.selectedDate = e;
    },
    disableDate(date) {
      return this.selectedDate
        ? date > new Date(this.selectedDate).getTime() + 7.949e9 ||
        date < new Date(this.selectedDate).getTime() - 7.949e9
        : false; // 3 months in milliseconds
    },
    hideModal(id) {
      // console.log("hidemodal");
      this.$bvModal.hide(id);
    },

    range(start, end) {
      return Array.from({ length: end - start + 1 }, (_, i) => i + start);
    },

    showManageVisitBtn(data) {
      // console.log(data);
      const expectedOrRejectedVisit =
        data.Data.isExpectedScanExist || data.Data.isRejectedScanExist;
      const noShowVisit = data.Data.isNoShowScanExist; // check grace period

      if (
        expectedOrRejectedVisit &&
        !noShowVisit &&
        !data.Data.denied_scan &&
        !data.Data.signed_in_scan &&
        !data.Data.auto_signed_in_scan &&
        !data.Data.isGracePeriodExpired &&
        data.pre_registration_method ==
        "PRE_REGISTRATION_WITH_APPROVAL_REQUIRED"
      )
        return true;
      return false;
    },
    resetDate() {
      this.dateRange = [
        moment(new Date().setHours(0, 0, 0, 0))
          .utc()
          .format("YYYY-MM-DD HH:mm:ss"),
        moment(new Date().setHours(23, 59, 59, 999))
          .utc()
          .format("YYYY-MM-DD HH:mm:ss"),
      ];
      this.dateRangeLocal = [
        moment
          .utc(new Date(Date.now()))
          .tz(moment.tz.guess())
          .format("YYYY-MM-DD"),
        moment
          .utc(new Date(Date.now()))
          .tz(moment.tz.guess())
          .format("YYYY-MM-DD"),
      ];
      this.dateChanged();
    },
    async customLoad() {
      if (this.userEmail !== "lt_techteam@visipoint.com" && !this.isEdit) {
        await this.onTableHeader({
          url: "/dailylog-data-grid",
          // headers: reportHistoryColumns,
        });
        let value = this.getTableHeaders;
        if (value) {
          value.pageIndex = 0;
          value.pageSize = 25;
          for (let i = 0; i < value.columns.length; i++) {
            if (
              value.columns[i].dataField == "ExpectedTime" &&
              value.columns[i].visibleIndex == 19
            ) {
              value.columns[i].visibleIndex = 7;
            } else if (
              value.columns[i].dataField == "CurrentJourneyStage" &&
              value.columns[i].visibleIndex == 18
            ) {
              value.columns[i].visibleIndex = 5;
            } else if (
              value.columns[i].dataField == "currentReason"
              // && value.columns[i].visibleIndex == 19
            ) {
              value.columns[i].visibleIndex = 6;
            } else if (
              value.columns[i].dataField == "UserData" &&
              !this.showUserData
            ) {
              value.columns[i].visible = false;
            }
            // value.columns[i].filterValues = null;
            // value.columns[i].sortOrder = null;
          }
        }
        return value;
      }
    },

    customSave(gridState) {
      if (this.userEmail !== "lt_techteam@visipoint.com" && !this.isEdit) {
        gridState.pageIndex = 0;
        gridState.pageSize = 25;
        gridState.selectedRowKeys = [];
        let value = JSON.stringify(gridState);
        value = value.replace(',"selectedRowKeys":[]', "");

        if (!this.getTableHeaders) {
          this.createTableHeaders({
            url: "/dailylog-data-grid",
            headers: value,
            filters: "[]",
          });
        } else if (value != JSON.stringify(this.getTableHeaders)) {
          this.updateTableHeaders({
            url: "/dailylog-data-grid",
            headers: value,
            filters: "[]",
          });
        }
      }
    },
    async openCheckInModal(data) {
      this.checkInStatus = data.Status;
      this.checkInData = {
        ...data.Data,
      };
      // console.log("kkk", this.checkInData);
      setTimeout(() => {
        this.$refs.checkInUser.$el.click();
      }, 400);
    },
    changeFullText(data, sub) {
      // console.log('changeFullText', data.id);
      const newNotes = this.trimText(
        data.originalVisitNotes,
        !data.showingFullText
      );
      if (sub) {
        data.notes = newNotes;
        data.showingFullText = !data.showingFullText;
        this.subGrid
          .getDataSource()
          .store()
          .push([
            {
              type: "update",
              key: { id: data.id },
              data: {
                showingFullText: !data.showingFullText,
                notes: newNotes,
              },
            },
          ]);
      } else {
        this.dataGrid
          .getDataSource()
          .store()
          .push([
            {
              type: "update",
              key: { visit_id: data.visit_id, user_id: data.user_id },
              data: {
                showingFullText: !data.showingFullText,
                visitNotes: newNotes,
              },
            },
          ]);
      }
    },

    trimText(data, showingFullText) {
      if (showingFullText) {
        return data;
      }
      return data && data !== "-" && data.length > 37
        ? `${data.slice(0, 37).trim()}...`
        : data;
    },

    calculateLabelValue(rowData) {
      const labelArr = [];
      if (
        rowData.Data.userData &&
        rowData.Data.userData.labels &&
        rowData.Data.userData.labels.length
      ) {
        rowData.Data.userData.labels.map((item) => {
          const labelExist = this.allLabels.find(
            (label) => label.id == item.mapping_value
          );
          if (labelExist) labelArr.push(labelExist.name);
        });
      }
      return labelArr.length ? labelArr.join(" - ") : "-";
    },

    validatePhone(e) {
      // console.log("validatePhone", this.isWalkinUser, this.isSystemUser, e);
      // var key = e.validator.option("validationGroup").key;
      // var rowIndex = this.dataGrid.getRowIndexByKey(key);
      // this.dataGrid.getDataSource()._items[rowIndex].Phone = e.value;
      if (
        !this.isWalkinUser &&
        this.isSystemUser &&
        !e.value &&
        (!e.data.EmailAddress ||
          e.data.EmailAddress == "-" ||
          e.data.countryCode)
      ) {
        // console.log('failed');
        return false;
      } else if (!e.value && e.data.countryCode) {
        return false;
      }
      return true;
      // console.log(this.dataGrid.option("formData").Phone);
    },
    async asyncValidation(params) {
      console.log("asyncValidation", params);
      if (params.value) {
        let formData = new FormData();
        formData.append("entity_id", params.data.entity_id);
        formData.append("user_id", params.data.user_id);
        formData.append("field", "email");
        formData.append("value", params.value);
        const data = await this.fetchUsersByEmailOrPhone(formData);
        return data.data.available;
      } else return true;
    },
    async asyncPhoneValidation(params) {
      console.log("asyncPhoneValidation", params);
      if (params.value) {
        let formData = new FormData();
        formData.append("entity_id", params.data.entity_id);
        formData.append("user_id", params.data.user_id);
        formData.append("field", "phone");
        formData.append("value", params.data.countryCode + params.value);
        const data = await this.fetchUsersByEmailOrPhone(formData);
        return data.data.available;
      } else return true;
    },
    validateEmail(e) {
      console.log("validateEmailvalidateEmailvalidateEmail");
      // console.log("validateEmail", this.isWalkinUser, this.isSystemUser, e);
      if (
        !this.isWalkinUser &&
        this.isSystemUser &&
        !e.value &&
        (!e.data.PhoneNumber || e.data.PhoneNumber == "-")
      ) {
        // console.log('failed');
        return false;
      }
      return true;
      // console.log(this.dataGrid.option("formData").Phone);
    },
    // validateLastName(e) {
    //   if (this.isWalkinUser) return true;
    //   else if (!e.value) return false;
    //   return true;
    // },
    validateCountryCode(e) {
      // console.log('val cc', e);
      if (!e.value && e.data.PhoneNumber != this.phone) return false;
      // else if (!e.value) return false;
      return true;
    },
    dateChanged() {
      if (this.dateRangeLocal[0])
        this.dateRange[0] = moment(
          new Date(this.dateRangeLocal[0] + "T00:00:00.000")
        )
          .utc()
          .format("YYYY-MM-DD HH:mm:ss");
      if (this.dateRangeLocal[1])
        this.dateRange[1] = moment(
          new Date(this.dateRangeLocal[1] + "T23:59:59.999")
        )
          .utc()
          .format("YYYY-MM-DD HH:mm:ss");
      // console.log(this.dateRange[0], this.dateRange[1]);
      if (this.dateRangeLocal.length == 0 || !this.dateRangeLocal[0]) {
        (this.dateRangeLocal = [
          moment
            .utc(new Date(Date.now()))
            .tz(moment.tz.guess())
            .format("YYYY-MM-DD"),
          moment
            .utc(new Date(Date.now()))
            .tz(moment.tz.guess())
            .format("YYYY-MM-DD"),
        ]),
          (this.dateRange = [
            moment(new Date().setHours(0, 0, 0, 0))
              .utc()
              .format("YYYY-MM-DD HH:mm:ss A"),
            moment(new Date().setHours(23, 59, 59, 999))
              .utc()
              .format("YYYY-MM-DD HH:mm:ss A"),
          ]);
      }
      // console.log(
      //   "datechanged",
      //   this.dateRange,
      //   JSON.stringify(this.dateRange)
      //   // JSON.stringify(this.dateRange) != this.getTableFilters
      // );
      // let finalFilterObject;
      // if (JSON.stringify(this.dateRange) != this.getTableFilters)
      //   this.updateTableHeaders({
      //     url: "/",
      //     headers: JSON.stringify(this.getTableHeaders),
      //     filters: JSON.stringify(this.dateRange),
      //   });
      if (!this.dateRange[0]) {
        const i = this.multipleFilters.findIndex((item) => item["Date"]);
        // console.log("index", i);
        this.multipleFilters.splice(i, 1);
        // console.log(this.multipleFilters);
      } else {
        this.finalFilterObject["Date"] = {
          start: this.dateRange[0].replace(/\//g, "-"),
          end: this.dateRange[1].replace(/\//g, "-"),
        };
        // const filter = this.multipleFilters.find(item => item['Date']);
        // if (filter) {
        const i = this.multipleFilters.findIndex((item) => item["Date"]);
        this.multipleFilters.splice(i, 1);
        // console.log("finl", this.multipleFilters);
        // }
        this.multipleFilters.push(this.finalFilterObject);
        // console.log(this.finalFilterObject);
      }

      // Check if the date range exceeds 3 months
      const start = moment(this.dateRange[0]);
      const end = moment(this.dateRange[1]);
      const diffMonths = end.diff(start, "months");
      if (diffMonths > 3) {
        this.dateRange[1] = moment(
          new Date(this.dateRangeLocal[0] + "T23:59:59.999")
        )
          .utc()
          .add(3, "months")
          .format("YYYY-MM-DD HH:mm:ss");
        this.dateRangeLocal[1] = moment(this.dateRangeLocal[0])
          .add(3, "months")
          .format("YYYY-MM-DD HH:mm:ss");
      }

      this.dataGrid.refresh().then(function () {
        console.log("refreshed");
      });
    },
    serverSideExport(e) {
      this.exportJobBE({
        type: e.itemData,
        // headers: columns.reduce((accumulator, value) => {
        //   return { ...accumulator, [value]: value };
        // }, {}),
        gridName: "dashboard",
        entity_id: this.currentEntity.id,
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        // filterBy: this.finalFilterObject,
        // orderBy: this.sortObject,
      });
    },
    openCompModal(data, manageVisit) {
      this.modalLoading = true;
      this.$bvModal.show("visit_modal");
      this.setVisitApproved(null);
      this.setVisitRejected(null);
      this.setApproveVisit(false);
      this.setRejectVisit(false);
      this.selectComplianceCreated(null);
      this.visitRejected = false;
      this.visitApproved = false;
      this.visitModalTitle = manageVisit
        ? this.$t("common.manageVisit")
        : this.$t("common.fillInCompliance");
      this.manageVisit = manageVisit;
      this.visitData = data;
      // console.log("data", data);
      this.firstName = data.FirstName;
      this.lastName = data.LastName;
      this.id = data.user_id;
      this.visitId = data.visit_id;
      this.userTypeId = data.user_type_id;
      this.areaId = data.area_id;
      const rejectedVisit =
        data.Data.isRejectedScanExist && !data.Data.isExpectedScanExist;

      const approvedVisit =
        data.Data.isExpectedScanExist && data.Data.isApprovedScanExist;
      const expectedVisit = data.Data.isExpectedScanExist;

      if (
        data.pre_registration_method ==
        "PRE_REGISTRATION_WITH_APPROVAL_REQUIRED"
      ) {
        if (rejectedVisit) {
          this.visitRejected = true;
          this.action_by = data.Data.RejectedScanFullName;
          this.scan_time = data.Data.RejectedScanTime;
          this.rejectionReason = data.Data.RejectedScanNotes;
        } else if (
          expectedVisit &&
          approvedVisit &&
          data.Data.expectedJourneyStageId == "ready_to_sign_in"
        ) {
          // Approved Visit
          this.visitApproved = true;
          this.action_by = data.Data.ApprovedScanFullName;
          this.scan_time = data.Data.ApprovedScanTime;
        }
      }
      this.fetchUserCompliance({
        user_id: data.user_id,
        user_type_id: data.user_type_id,
        area_id: data.area_id,
        visit_id: data.visit_id,
        entity_id: data.entity_id,
      }).then(() => {
        // setTimeout(() => {
        //   setTimeout(() => {
            this.modalLoading = false;
        //     this.fetchAreaDocument({
        //       area_id: data.area_id,
        //       user_id: data.user_id,
        //     });
        //   }, 200);
        // }, 500);
      });
    },
    openVisitNotes(visitData) {

      this.selectedVisit = visitData;
      this.$bvModal.show("add_visit_notes_modal");


    },
    addVisitNotes() {
      // console.log(this.visit_id, this.visitNotes, this.visitNotesCopy);
      if (!this.visitNotes) return;
      this.$store.dispatch("dailyLogbook/addVisitNotes", {
        visit_id: this.visit_id,
        notes: this.visitNotes,
      });
      this.dataGrid.refresh().then(function () {
        console.log("refreshed");
      });
      this.$bvModal.hide("visitNotes");
    },
    logPaste(event) {
      console.log("paste", event);
      // var clipboardData, pastedData;

      //   event.stopPropagation();
      //   event.preventDefault();

      //   clipboardData = event.clipboardData || window.clipboardData;
      //   pastedData = clipboardData.getData('Text');

      // var data = pastedData;

      // var rows = data.split("\n");
      // console.log("rows :" + rows);
      // for(var y in rows) {
      //   var cells = rows[y].split("\t");
      //   if(cells !== "" || cells !== null){
      //     console.log("cells :" + cells);
      //     console.log("customers :" + customers);
      //     customers.push({"FirstName":cells[0],"LastName":cells[1],"Age":cells[2],"Email":cells[3]});
      //   }
      // }
      // bindGrid();
    },
    onCellPrepared(e) {
      if (e.rowType === "data" && e.column.command === "edit") {
        if (e.row.data?.is_active == 0) {
          e.cellElement.innerText = " - ";
        }
      }
    },
    start(e) {
      if (e.data.user_id.includes("undefined") || this.isSelectionMode) {
        e.cancel = true;
        return;
      }
      this.editingVisitId = e.data.visit_id;
      this.visit_id = e.key.visit_id;
      this.email = e.data.EmailAddress;
      this.isWalkinUser = e.data.Data.is_default_user;
      this.phone = e.data.PhoneNumber;
      // e.data.user_id == e.data.entity_id + "-" + e.data.user_type_id;
      // console.log("isWalkinUser", this.isWalkinUser);
      this.isSystemUser = e.data.user.system_user;
      // console.log("isSystemUser", this.isSystemUser);
      let value = this.getTableHeaders;
      if (value) {
        value.pageIndex = 0;
        value.pageSize = 50;
        for (let i = 0; i < value.columns.length; i++) {
          if( value.columns[i].dataField == "PhoneNumber" ){
            console.log('value.columns[i]', value.columns[i])
            if( value.columns[i].visible ) this.isEdit = true;
          } 
        }
      }
      this.editedUser = e.data;
    },
    updateRow(event) {
      let formData = new FormData();
      this.isEdit = false;
      // console.log("event", event, this.editedUser);
      const row = this.dataGrid
        .getDataSource()
        ._items.find((item) => item.visit_id == event.key.visit_id);
      // console.log("row", row);
      const { updateUserAction, addUserWalkin } = this;
      const entity_id = store.getters["authfack/currentEntity"].id;
      // console.log(' entity_id',  entity_id)
      // const update = true;
      const { user_user_id, system_user, user_type_id } = row;
      const FirstName = event.data.FirstName
        ? event.data.FirstName
        : row.FirstName;
      const LastName = event.data.LastName ? event.data.LastName : row.LastName;
      const RFID =
        event.data.RFID || event.data.RFID == ""
          ? event.data.RFID
          : row.RFID
            ? row.RFID.map((rfid) => {
              return rfid.rfid_number;
            })
            : null;
      // const companyName =
      //   event.data.companyName || event.data.companyName == ""
      //     ? event.data.companyName
      //     : row.companyName;
      // const vehicleRegistration =
      //   event.data.vehicleRegistration || event.data.vehicleRegistration == ""
      //     ? event.data.vehicleRegistration
      //     : row.vehicleRegistration;
      const phone =
        event.data.countryCode ||
          event.data.PhoneNumber == "" ||
          (event.data.PhoneNumber && event.data.PhoneNumber.length > 0)
          ? event.data.countryCode
            ? event.data.countryCode + "" + event.data.PhoneNumber
            : event.data.PhoneNumber
          : row.PhoneNumber
            ? row.PhoneNumber
            : null;
      const email =
        event.data.EmailAddress == "" ||
          (event.data.EmailAddress && event.data.EmailAddress.length > 0)
          ? event.data.EmailAddress
          : row.EmailAddress;
      let data;
      if (this.isWalkinUser) {
        let length = 8,
          charset =
            "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789",
          retVal = "";
        let i = 0,
          n = charset.length;
        for (; i < length; ++i) {
          retVal += charset.charAt(Math.floor(Math.random() * n));
        }
        data = {
          entity_id,
          user_user_id: "VP-" + retVal,
          first_name: FirstName,
          last_name: LastName,
          email,
          user_type_id,
          system_user: 0,
          // password,
          // company_name: companyName,
          // vehicle_registration: vehicleRegistration,
          visit_id: this.editedUser.visit_id,
        };
        if (RFID) data.rfid_number = RFID;
        if (phone) data.phone = phone;
      } else {
        data = {
          entity_id,
          user_user_id,
          first_name: FirstName,
          last_name: LastName,
          email,
          user_type_id,
          system_user,
          // password,
          // company_name: companyName,
          rfid_number: RFID,
          phone,
          // vehicle_registration: vehicleRegistration,
          visit_id: this.editedUser.visit_id,
        };
        // if (RFID) data.rfid_number = RFID;
        // if (phone) data.phone = phone;
      }
      formData.append("entity_id", data.entity_id);
      formData.append("user_user_id", data.user_user_id);
      formData.append("first_name", data.first_name);
      formData.append("last_name", data.last_name);
      if (!this.isWalkinUser || data.email)
        formData.append("email", data.email ? data.email : "");
      formData.append("user_type_id", data.user_type_id);
      formData.append("system_user", data.system_user);
      // formData.append("password", data.password);
      formData.append(
        "company_name",
        data.company_name ? data.company_name : ""
      );
      if (!this.isWalkinUser || data.rfid_number) {
        if (data.rfid_number?.length) {
          for (let i = 0; i < data.rfid_number.length; i++) {
            formData.append("rfid_number[]", data.rfid_number[i]);
          }
        } else {
          formData.append("rfid_number", "");
        }
      }
      if (!this.isWalkinUser || data.phone)
        formData.append("phone", data.phone ? data.phone : "");
      formData.append(
        "vehicle_registration",
        data.vehicle_registration ? data.vehicle_registration : ""
      );
      if (this.isWalkinUser) formData.append("visit_id", data.visit_id);

      this.isWalkinUser
        ? addUserWalkin({ user: formData })
        : updateUserAction({ id: event.key.user_id, user: formData });

      this.editingVisitId = null;
      setTimeout(() => {
        this.dataGrid.refresh().then(function () {
          console.log("refreshed");
        });
      }, 3000);
    },
    reset() {
      this.dataGrid.clearFilter("row");
      this.dataGrid.clearFilter("header");
      this.dataGrid.clearSorting();
      this.showClearAll = false;
      // this.dateRange = [];
      // this.dateChanged();
    },
    contentReady(e) {
      // console.log("ready", e);
      let sortedExp = this.getSortedColumns();
      let filterExp = e.component.getCombinedFilter();
      if (filterExp || sortedExp) {
        this.showClearAll = true;
      } else {
        this.showClearAll = false;
      }
      if (this.pageInit) this.setColumnChooserPosition();
      // if (this.needUpdateScrollPosition) {
      //   setTimeout(() => {
      //     console.log('needUpdateScrollPosition');
      //     const scrollable = e.component.getScrollable();
      //     const maxScrollLeft = scrollable.scrollWidth();
      //     console.log('s', scrollable, maxScrollLeft);

      //     scrollable.scrollTo({
      //       x: maxScrollLeft - 1233 // 2656 with inspect, 2220 without inspect
      //     });

      //     this.needUpdateScrollPosition = false;
      //   }, 1000);
      // }
    },
    getSortedColumns() {
      let allColumns = Array.from(
        Array(this.dataGrid.columnCount()).keys()
      ).map((index) => this.dataGrid.columnOption(index));
      allColumns = allColumns.find((col) => col.sortIndex != null);
      return allColumns;
    },
    visitNotesChanged(e) {
      // console.log('visitNotesChanged', e.target.value);
      this.visitNotes = e.target.value;
      if (!e.target.value) this.isDisabled = true;
      else this.isDisabled = false;
    },
    onEditorPreparing(e) {
      if (e.parentType === 'filterRow' && e.editorName === 'dxTextBox' && e.dataField && !e.dataField.includes("Data.customFields")) {
        const originalOnValueChanged = e.editorOptions.onValueChanged;

        e.editorOptions.onValueChanged = debounce((args) => {
          const value = args.value;

          // Only apply filter if 3 or more characters
          if (value && value.length >= 3) {
            originalOnValueChanged && originalOnValueChanged(args);
          } else if (value === '' || value == null) {
            // Allow clearing the filter
            originalOnValueChanged && originalOnValueChanged(args);
          } else {
            // Prevent filtering if less than 3 characters
            e.component.columnOption(e.dataField, 'filterValue', null);
          }
        }, 400); // debounce delay (ms)
      }
      if (e.parentType == "filterRow") {
        e.editorOptions.placeholder = this.$t("common.grid.search");
      }
      // setTimeout(() => {
      //   const el = document.querySelectorAll(".dx-link-edit");
      // if(this.isSelectionMode){
      //   if (el){
      //     el?.forEach(e=>{
      //       e.classList.add("dx-state-disabled")
      //     })
      //   }
      // }
      // }, 0);

      // let dataGrid = e.component;
      if (e.command === "select") {
        if (e.parentType === "dataRow" && e.row) {
          // console.log("row", e.row.data);
          if (!this.checkIfSelectable(e.row.data)) {
            e.editorOptions.disabled = true;
          }
          if (this.disableCheckbox(e.row.data)) {
            e.editorOptions.disabled = true;
            e.editorOptions.readOnly = true;
          }
        }
      }
    },
    onRowPrepared(e) {
      if (e.rowType === "data" && e.data.Data.is_undefined_user) {
        e.rowElement.classList.add("hideButton");
      }
      if (
        e.data &&
        e.data.CurrentJourneyStageID &&
        (e.data.CurrentJourneyStageID == "waiting_for_admin_approval" ||
          e.data.CurrentJourneyStageID ==
          "waiting_for_admin_approval_compliance_failed")
      ) {
        e.rowElement.classList.add("waiting-for-approval-style");
      }
    },
    setColumnChooserPosition() {
      // this.dataGrid.showColumnChooser();
      this.pageInit = false;
      // console.log("columnChooserView");

      var columnChooserView = this.dataGrid.getView("columnChooserView");

      if (!columnChooserView._popupContainer) {
        columnChooserView._initializePopupContainer();
        columnChooserView.render();
      }

      columnChooserView._popupContainer.option("position", {
        of: this.dataGrid.element(),
        my: this.getLanguage == "en" ? "left top" : "right top",
        at: this.getLanguage == "en" ? "left top" : "right top",
        offset: "0 50",
      });
    },
    checkPermissions(data) {
      if (
        (data.scan_data_type_id == 6 &&
          (!data.haveExpectedPermittedUserType ||
            !data.hasPermissionOnProfileUserType)) ||
        (data.scan_data_type_id != 6 && !data.havePermittedUserType)
      ) {
        if (data.Data.isExpectedScanExist) {
          // has expected scan
          let userTimezone = moment.tz.guess();
          if (
            moment
              .utc(new Date(Date.now()))
              .tz(userTimezone)
              .format("YYYY-MM-DD") <
            moment
              .utc(data.Data.expectedScanTime)
              .tz(userTimezone)
              .format("YYYY-MM-DD")
          )
            return true;
          return false;
        }
      }
      return false;
    },
    cantEnterArea(data) {
      if (!data.havePermittedUserType || !data.hasPermissionOnProfileUserType) {
        const arr1 = ["16", "1", "5", "4", "8"]; // [Rejected, Checked in, Denied, Signed out / Auto signed out]
        const arr2 = ["1", "5", "4", "8"]; // [Checked in, Denied, Signed out / Auto signed out]
        const visitRejected = data.Data.isRejectedScanExist;
        const expectedScan = data.Data.isExpectedScanExist;
        const visitDeleted = data.Data.isDeletedScanExist;
        const noShow = data.Data.isNoShowScanExist;
        // if (data.scan_data_type_id == 6) return true;
        if (
          arr1.includes(data.scan_data_type_id) &&
          visitRejected &&
          !expectedScan
        ) {
          console.log('hi');
          return true;
        }
        else if (arr2.includes(data.scan_data_type_id) && !expectedScan)
          return true;
        else if (
          (data.scan_data_type_id == 17 && visitDeleted) ||
          (data.scan_data_type_id == 7 && noShow) ||
          (data.scan_data_type_id == 6 && noShow)
        )
          return true;
        else return false;
      }
      return false;
    },
    disableCheckbox(data) {
      const expectedScan = data.Data.isExpectedScanExist;
      const rejectedScan = data.Data.isRejectedScanExist;
      const arr2 = ["16", "1", "5", "4", "8"]; // [Rejected, Checked in, Denied, Signed out / Auto signed out]
      const arr3 = ["3", "9"]; // [Signed in, Auto signed in]

      if (expectedScan && !data.hasPermissionOnProfileUserType) return false;
      else if (
        !data.hasPermissionOnProfileUserType &&
        arr2.includes(data.scan_data_type_id) &&
        rejectedScan &&
        !expectedScan
      ) {
        if (data.isGracePeriodExpired) return true;
        else return false;
      } else if (
        !data.hasPermissionOnProfileUserType &&
        rejectedScan &&
        !expectedScan &&
        arr3.includes(data.scan_data_type_id)
      )
        return false;
      else if (
        !data.hasPermissionOnProfileUserType &&
        arr3.includes(data.scan_data_type_id)
      )
        return false;
      else if (!data.hasPermissionOnProfileUserType) return true;
      return false;
    },
    getCheckboxVal(data) {
      const parsedArray = JSON.parse(data);
      if (Array.isArray(parsedArray)) {
        return parsedArray.join(" - ");
      } else {
        return "-";
      }
    },
    setSmileysColor(scaleCount) {
      let smileyColors = [];
      switch (scaleCount) {
        case 2:
          smileyColors = ["rgb(230, 10, 62)", "rgb(25, 179, 148)"];
          break;
        case 3:
          smileyColors = [
            "rgb(230, 10, 62)",
            "rgb(255, 152, 20)",
            "rgb(25, 179, 148)",
          ];
          break;
        case 4:
          smileyColors = [
            "rgb(230, 10, 62)",
            "rgb(246, 104, 34)",
            "rgb(178, 161, 62)",
            "rgb(25, 179, 148)",
          ];
          break;
        case 5:
          smileyColors = [
            "rgb(230, 10, 62)",
            "rgb(242, 81, 41)",
            "rgb(255, 152, 20)",
            "rgb(140, 165, 84)",
            "rgb(25, 179, 148)",
          ];
          break;
        case 6:
          smileyColors = [
            "rgb(230, 10, 62)",
            "rgb(240, 66, 45)",
            "rgb(250, 123, 28)",
            "rgb(209, 157, 45)",
            "rgb(117, 168, 96)",
            "rgb(25, 179, 148)",
          ];
          break;
        case 7:
          smileyColors = [
            "rgb(230, 10, 62)",
            "rgb(238, 57, 48)",
            "rgb(246, 104, 34)",
            "rgb(255, 152, 20)",
            "rgb(178, 161, 62)",
            "rgb(101, 170, 105)",
            "rgb(25, 179, 148)",
          ];
          break;
        case 8:
          smileyColors = [
            "rgb(230, 10, 62)",
            "rgb(237, 50, 50)",
            "rgb(244, 91, 38)",
            "rgb(251, 131, 26)",
            "rgb(222, 155, 38)",
            "rgb(156, 163, 74)",
            "rgb(90, 171, 111)",
            "rgb(25, 179, 148)",
          ];
          break;
        case 9:
          smileyColors = [
            "rgb(230, 10, 62)",
            "rgb(236, 45, 51)",
            "rgb(242, 81, 41)",
            "rgb(248, 116, 30)",
            "rgb(255, 152, 20)",
            "rgb(197, 158, 52)",
            "rgb(140, 165, 84)",
            "rgb(82, 172, 116)",
            "rgb(25, 179, 148)",
          ];
          break;
        case 10:
          smileyColors = [
            "rgb(230, 10, 62)",
            "rgb(235, 41, 52)",
            "rgb(241, 73, 43)",
            "rgb(246, 104, 34)",
            "rgb(252, 136, 24)",
            "rgb(229, 155, 34)",
            "rgb(178, 161, 62)",
            "rgb(127, 167, 91)",
            "rgb(76, 173, 119)",
            "rgb(25, 179, 148)",
          ];
          break;
      }

      return smileyColors;
    },
    setSmileysText(scaleCount) {
      let smileyText = [];
      switch (scaleCount) {
        case 3:
          smileyText = ["Poor", "OK", "Good"];
          break;
        case 5:
          smileyText = ["Bad", "Poor", "OK", "Good", "Great"];
          break;
      }
      return smileyText;
    },
    getRatingScaleData(data) {
      let customField;
      customField = this.dailyLogCustomFields.find(
        (field) => field.id == data.column.dataField.split(".")[2]
      );
      const smileyColors = this.setSmileysColor(
        customField.metadata[0].scale_count
      );
      const smileyText = this.setSmileysText(
        customField.metadata[0].scale_count
      );
      const visibleSmiley =
        this.smileysToShow[customField.metadata[0].scale_count - 2];
      return {
        smileySvg: smileysJson[visibleSmiley[+data.value - 1] + "Colored"],
        smileyColor: smileyColors[+data.value - 1],
        smileyText: smileyText[+data.value - 1],
      };
    },
    onDataErrorOccurred(e) {
      console.log('onDataErrorOccurred e', e);
      setTimeout(() => {
        let errorRow = document.querySelector(".dx-datagrid-headers .dx-error-message");
        errorRow.innerHTML = this.$t('common.notes.anErrorOccurredGrid');
      }, 100);
    },
    async renderDashboardGridData() {
      this.dataGrid.beginCustomLoading();
      this.dataStore = await new CustomStore({
        // key: 'id',
        key: ["visit_id", "user_id"],
        load: (loadOptions) => {
          // if (!this.isGridReady) return { data: [], totalCount: 0 }; // Prevent initial API call
          this.gridEmptyMessage = this.$t('common.grid.loadingData');
          let params = "?";
          let filterQuery = "";
          let sortObject = { sortField: null, sortOrder: "" };
          [
            "skip",
            "take",
            "requireTotalCount",
            "requireGroupCount",
            "sort",
            "filter",
            "totalSummary",
            "group",
            "groupSummary",
          ].forEach((i) => {
            if (i in loadOptions && isNotEmpty(loadOptions[i])) {
              params += `${i}=${JSON.stringify(loadOptions[i])}&`;
              if (i == "filter")
                filterQuery += `${JSON.stringify(loadOptions[i])}`;
              if (i == "sort") {
                sortObject.sortField = loadOptions[i][0].selector;
                sortObject.sortOrder = loadOptions[i][0].desc ? "desc" : "asc";
              }
            }
          });
          this.resetDashboardData();
          // params.slice(0, -1);
          params = params.slice(0, -1);
          let filters;
          let finalFilterObject = {};
          this.multipleFilters = this.dateRange[0]
            ? [
              {
                Date: {
                  start: this.dateRange[0],
                  end: this.dateRange[1],
                },
              },
            ]
            : [];
          if (filterQuery) filters = JSON.parse(filterQuery);
          if (filters) console.log("filters", filters);
          if (filters && typeof filters[0] === "string") {
            if (filters[0] == "!") {
              console.log("not");
              if (typeof filters[1] === "object") {
                const excludeIds = [];
                const columnHeader =
                  typeof filters[1][0] === "object"
                    ? filters[1][0][0] + "HeaderFilter"
                    : filters[1][0] + "HeaderFilter";
                const columnHeaderFilter =
                  columnHeader.charAt(0).toLowerCase() + columnHeader.slice(1);
                console.log(columnHeader); // name of column filter
                if (typeof filters[1][0] === "object") {
                  console.log("obj");
                  filters[1].map((item) => {
                    if (typeof item === "object") {
                      console.log("item", item[2][0]);
                      excludeIds.push(item[2][0]);
                    }
                  });
                } else {
                  console.log("else");
                  // filters[1].map(item => {
                  // if (typeof item === "object") {
                  console.log("item", filters[1][2][0]);
                  excludeIds.push(filters[1][2][0]);
                  // }
                  // });
                }
                console.log(this[columnHeaderFilter]);
                const arr = this[columnHeaderFilter].filter(
                  (el) => !excludeIds.includes(el.value[2][0])
                );
                console.log("arr", arr, excludeIds);
                if (typeof filters[1][0] === "object") {
                  finalFilterObject[filters[1][0][0]] = arr.map((item) => {
                    return item.value[2][0];
                  });
                } else {
                  finalFilterObject[filters[1][0]] = arr.map((item) => {
                    return item.value[2][0];
                  });
                }
                console.log("finalFilterObject", finalFilterObject);
                if (this.multipleFilters.length > 0) {
                  this.multipleFilters.push(finalFilterObject);
                }
              }
            } else {
              if (
                (filters[1] === "contains" || filters[1] === "=") &&
                this.allFilterHeaders.includes(filters[0])
              )
                filters[2] = [filters[2]]; // make it array;
              finalFilterObject[filters[0]] =
                filters[1] === "contains" || filters[1] === "="
                  ? filters[2]
                  : filters[2];
            }
            if (this.multipleFilters.length > 0) {
              this.multipleFilters.push(finalFilterObject);
            }
          } else {
            // const isOr = filters[1] === 'or';
            // const isAnd = filters[1] === 'and';
            if (filters)
              for (const filter of filters) {
                // console.log('filter', filter);
                // not filter
                if (filter[0] == "!") {
                  // console.log('multiple filters not');
                  if (typeof filter[1] === "object") {
                    const excludeIds = [];
                    const columnHeader =
                      typeof filter[1][0] === "object"
                        ? filter[1][0][0] + "HeaderFilter"
                        : filter[1][0] + "HeaderFilter";
                    const columnHeaderFilter =
                      columnHeader.charAt(0).toLowerCase() +
                      columnHeader.slice(1);
                    // console.log(columnHeader); // name of column filter
                    if (typeof filter[1][0] === "object") {
                      // console.log('obj');
                      filter[1].map((item) => {
                        if (typeof item === "object") {
                          // console.log('item', item[2][0]);
                          excludeIds.push(item[2][0]);
                        }
                      });
                    } else {
                      // console.log('else');
                      // filters[1].map(item => {
                      // if (typeof item === "object") {
                      // console.log('item', filter[1][2][0]);
                      excludeIds.push(filter[1][2][0]);
                      // }
                      // });
                    }
                    // console.log(this[columnHeaderFilter]);
                    const arr = this[columnHeaderFilter].filter(
                      (el) => !excludeIds.includes(el.value[2][0])
                    );
                    // console.log('arr', arr, excludeIds);
                    if (typeof filter[1][0] === "object") {
                      finalFilterObject[filter[1][0][0]] = arr.map((item) => {
                        return item.value[2][0];
                      });
                    } else {
                      finalFilterObject[filter[1][0]] = arr.map((item) => {
                        return item.value[2][0];
                      });
                    }
                    // console.log('finalFilterObject', finalFilterObject);
                    if (this.multipleFilters.length > 0) {
                      this.multipleFilters.push(finalFilterObject);
                    }
                  }
                }
                let orExist;
                let andExist;
                if (typeof filter === "object") {
                  // console.log('obj', filter);
                  orExist = filter.find((item) => item === "or");
                  andExist = filter.find((item) => item === "and");
                  if (filter[1] == "or") {
                    // Header Filter - Gather In One Condition
                    if (
                      filter[0][1] === ">=" ||
                      filter[0][1] === "<=" ||
                      filter[0][1] === "<"
                    ) {
                      const finalFilter = {};
                      const condition = [];
                      for (const filterItem of filter) {
                        if (filterItem[2]) condition.push(filterItem[2][0]);
                      }
                      finalFilter[filter[0][0]] = {
                        start: condition[0].replace(/\//g, "-"),
                        end: condition[1].replace(/\//g, "-"),
                      };
                      this.multipleFilters.push(finalFilter);
                    } else {
                      // Gather In One Condition
                      for (const filter of filter) {
                        if (filter[1] === "contains" || filter[1] === "=") {
                          if (this.allFilterHeaders.includes(filter[0]))
                            filter[2] = [filter[2]]; // make it array;
                          const finalFilter = {};
                          finalFilter[filter[0]] =
                            filter[1] === "contains" || filter[1] === "="
                              ? filter[2]
                              : filter[2];

                          // Header Filter - Gather In One Condition
                          const filterExist = this.multipleFilters.find(
                            (item) => item[filter[0]]
                          );
                          if (!filterExist)
                            this.multipleFilters.push(finalFilter);
                          else filterExist[filter[0]].push(filter[2][0]);
                        }
                      }
                    }
                  } // -------------- Header Filter --------------------
                  if (filter[1] == "and" && filter[0][1] == ">=") {
                    // Range Condition
                    const finalFilter = {};
                    const condition = [];
                    //"ArrivalTime":{"start":"2022-03-10 00:00:00","end":"2022-03-12 23:59:59"}
                    for (const filterItem of filter) {
                      if (typeof filterItem === "object" && filterItem[2])
                        condition.push(filterItem[2]);
                    }
                    finalFilter[filter[0][0]] = {
                      start: condition[0].replace(/\//g, "-"),
                      end: condition[1].replace(/\//g, "-"),
                    };
                    this.multipleFilters.push(finalFilter);
                  } // -------------- Range Condition --------------------
                }
                if (
                  filter.length > 0 &&
                  filter[0] &&
                  filter[0] !== "Actions" &&
                  !orExist &&
                  !andExist
                ) {
                  if (filter[1] === "contains" || filter[1] === "=") {
                    if (this.allFilterHeaders.includes(filter[0]))
                      filter[2] = [filter[2]]; // make it array;
                    const finalFilter = {};
                    finalFilter[filter[0]] =
                      filter[1] === "contains" || filter[1] === "="
                        ? filter[2]
                        : filter[2];

                    // Header Filter - Gather In One Condition
                    const filterExist = this.multipleFilters.find(
                      (item) => item[filter[0]]
                    );
                    if (!filterExist) this.multipleFilters.push(finalFilter);
                    else filterExist[filter[0]].push(filter[2][0]);
                  }
                  if (
                    filter[2] &&
                    (filter[1] === ">=" ||
                      filter[1] === "<=" ||
                      filter[1] === "<")
                  ) {
                    const finalFilter = {};
                    const filter2 =
                      typeof filter[2] !== "number" && filter[2].includes("/")
                        ? filter[2].replace(/\//g, "-")
                        : filter[2];
                    finalFilter[filter[0]] = { start: "", end: "" };
                    // Range Condition
                    const filterExist = this.multipleFilters.find(
                      (item) => item[filter[0]]
                    );
                    if (!filterExist) {
                      finalFilter[filter[0]].start = filter2;
                      this.multipleFilters.push(finalFilter);
                    } else filterExist[filter[0]].end = filter2;
                  }
                } else if (andExist) {
                  for (const andFilter of filter) {
                    if (
                      andFilter.length > 0 &&
                      andFilter[0] &&
                      andFilter[0] !== "Actions"
                    ) {
                      if (andFilter[1] === "contains" || andFilter[1] === "=") {
                        if (this.allFilterHeaders.includes(andFilter[0]))
                          andFilter[2] = [andFilter[2]]; // make it array;
                        const finalFilter = {};
                        finalFilter[andFilter[0]] =
                          andFilter[1] === "contains" || andFilter[1] === "="
                            ? andFilter[2]
                            : andFilter[2];
                        this.multipleFilters.push(finalFilter);
                      }
                      if (andFilter[1] === "and" && andFilter[0][1] == ">=") {
                        // range condition
                        const finalFilter = {};
                        const condition = [];
                        for (const filterItem of andFilter) {
                          const filterItem2 =
                            typeof filterItem[2] !== "number" &&
                              filterItem[2].includes("/")
                              ? filterItem[2].replace(/\//g, "-")
                              : filterItem[2];
                          if (typeof filterItem === "object" && filterItem[2])
                            condition.push(filterItem2);
                        }
                        finalFilter[andFilter[0][0]] = {
                          start: condition[0].replace(/\//g, "-"),
                          end: condition[1].replace(/\//g, "-"),
                        };
                        this.multipleFilters.push(finalFilter);
                      }
                    }
                  }
                }
              }
          }
          finalFilterObject =
            this.multipleFilters && this.multipleFilters.length > 0
              ? Object.assign({}, ...this.multipleFilters)
              : finalFilterObject;
          // console.log(
          //   "fffff",
          //   finalFilterObject,
          //   JSON.stringify(finalFilterObject)
          // );

          // Extract entries and filter only those with keys starting with "Data.customFields."
          const customFieldsEntries = Object.entries(finalFilterObject).filter(
            ([key]) => key.startsWith("Data.customFields.")
          );

          // Map the filtered entries to the new structure
          const customFieldsArray = customFieldsEntries.map(([key, value]) => {
            const customFieldId = key.split(".")[2]; // Extract the customFieldId part
            return {
              customFieldId,
              value,
            };
          });

          // Return the new structure
          const customFieldsFilter = {
            customFields: customFieldsArray,
          };

          for (var prop in finalFilterObject) {
            if (typeof finalFilterObject[prop] === "string") {
              finalFilterObject[prop] = finalFilterObject[prop].trim();
            }
          }
          let queryParams = {
            filterBy: finalFilterObject,
            customFieldsFilter,
            orderBy: sortObject ? sortObject : { sortField: null },
          };
          if (this.isExport) {
            queryParams.isExporting = true;
          }
          return Api()
            .get(
              `/visit_list_refactor/${store.getters["authfack/currentEntity"].id}${params}`,
              {
                params: queryParams,
              }
            )
            .then((data) => {
              // console.log("dashboarddata", data);
              const dd = [];
              // let entity = store.getters["authfack/currentEntity"];
              data.data.visits.map((scan) => {
                const isDeletedUser = this.checkIfUserIsDeleted(
                  scan?.entity_user_id
                );
                let userTimezone = moment.tz.guess();
                let imageScan = scan.profile_image ? scan.profile_image : scan.scan_image;
                // if (scan.scan[0])
                //   scan.scan.map((item) => {
                //     if (item.image && !imageScan)
                //         = item.image_base64
                //         ? item.image_base64
                //         : item.image;
                //   });
                // let degre =
                //   scan.scan && scan.scan[0] && scan.scan[0].temperature_type
                //     ? scan.scan[0].temperature_type == "f"
                //       ? scan.scan[0].temperature * (9 / 5) + 32
                //       : scan.scan[0].temperature
                //     : entity &&
                //       entity.setting &&
                //       entity.setting.length > 0 &&
                //       entity.setting[0].pivot.value == "f"
                //     ? scan.scan[0].temperature * (9 / 5) + 32
                //     : scan.scan[0].temperature;

                dd.push({
                  // showLocation: !!scans.find(item => !!item.location),
                  haveExpectedPermittedUserType:
                    scan.haveExpectedPermittedUserType,
                  havePermittedUserType: scan.havePermittedUserType,
                  hasPermissionOnProfileUserType:
                    scan.hasPermissionOnProfileUserType,
                  isGracePeriodExpired: scan.isGracePeriodExpired,
                  scan_data_type_id: scan.scan_data_type_id,
                  scan_data_type_name: scan.scan_data_type_name,
                  is_active: scan.is_active,
                  is_archived: scan.is_archived,
                  is_default_user: scan.is_default_user,
                  is_undefined_user: scan.is_undefined_user,
                  site_timezone: scan.timezone,
                  user_user_id: scan.user_user_id,
                  system_user: scan.system_user,
                  // scan_data_type: scan.scan_data_type
                  //   ? scan.scan_data_type
                  //   : "",
                  RFID:
                    isDeletedUser ||
                      (scan.scan_data_type_id == 5 &&
                        scan.user_id.includes("undefined"))
                      ? "-"
                      : scan.RFIDs?.length
                        ? scan.RFIDs
                        : null,
                  EmailAddress:
                    isDeletedUser ||
                      (scan.scan_data_type_id == 5 &&
                        scan.user_id.includes("undefined"))
                      ? ""
                      : scan.email
                      ? scan.email
                      : "",
                  PhoneNumber:
                    isDeletedUser ||
                      (scan.scan_data_type_id == 5 &&
                        scan.user_id.includes("undefined"))
                      ? ""
                      : scan.phone
                        ? scan.phone
                        : "",
                  // companyName:
                  //   isDeletedUser ||
                  //   (scan.scan_data_type_id == 5 &&
                  //     scan.user_id.includes("undefined"))
                  //     ? "-"
                  //     : scan.user && scan.user.company_name
                  //     ? scan.user.company_name
                  //     : "-",
                  // vehicleRegistration:
                  //   isDeletedUser ||
                  //   (scan.scan_data_type_id == 5 &&
                  //     scan.user_id.includes("undefined"))
                  //     ? "-"
                  //     : scan.user && scan.user.vehicle_registration
                  //     ? scan.user.vehicle_registration
                  //     : "-",
                  visitNotes:
                    scan.scan_data_type_id == 5
                      ? "-"
                      : scan.notes
                        ? this.trimText(scan.notes, false)
                        : "-",
                  originalVisitNotes: scan.notes ? scan.notes : "-",
                  showingFullText: false,
                  // faceID: scan.user ? scan.user.faceID : "",
                  ID:
                    isDeletedUser ||
                      (scan.scan_data_type_id == 5 &&
                        scan.user_id.includes("undefined"))
                      ? "-"
                      : scan.user_user_id
                        ? scan.user_user_id
                        : "-",
                  visit_id: scan.id,
                  user_id: scan.user_id,
                  user_type_id: scan.user_type_id,
                  user: scan.entity_user || scan.userData,
                  pre_registration_method: scan.pre_registration_method,
                  isDeletedUser,
                  // Picture: imageScan ? scan.scan[0].image_base64 : null, // base64Img
                  Image: imageScan ? imageScan : null, // base64Img
                  // 'https://upload.wikimedia.org/wikipedia/commons/thumb/b/b6/Image_created_with_a_mobile_phone.png/640px-Image_created_with_a_mobile_phone.png'
                  Status: scan.scan_data_type_name
                    ? scan.scan_data_type_name
                    : "-",
                  Label: scan.Labels,
                  CurrentJourneyStage: scan.journey_stage_text
                    ? scan.journey_stage_text
                    : "-",
                  Reason: scan.reason_name ? scan.reason_name : "-",
                  // scan.scan_data_type_id == 5
                  //   ? "-"
                  //   : scan.scan.find(
                  //       // stage of Expected or Rejected, else "-"
                  //       (item) =>
                  //         item.scan_data_type.id == 6 ||
                  //         item.scan_data_type.id == 15
                  //     )
                  //   ? scan.scan.find((item) => item.scan_data_type.id == 6)
                  //     ? scan.scan.find((item) => item.scan_data_type.id == 6)
                  //         .journey_stage_text
                  //     : scan.scan.find((item) => item.scan_data_type.id == 15)
                  //         .journey_stage_text
                  //   : scan.scan.find(
                  //       (item) =>
                  //         item.scan_data_type.id == scan.scan_data_type.id
                  //     )
                  //   ? scan.scan.find(
                  //       (item) =>
                  //         item.scan_data_type.id == scan.scan_data_type.id
                  //     ).journey_stage_text
                  //   : "-",
                  CurrentJourneyStageID: scan.journey_stage
                    ? scan.journey_stage
                    : "-",
                  // scan.scan.find(
                  //   // stage of Expected or Rejected, else "-"
                  //   (item) =>
                  //     item.scan_data_type.id == 6 ||
                  //     item.scan_data_type.id == 15
                  // )
                  //   ? scan.scan.find((item) => item.scan_data_type.id == 6)
                  //     ? scan.scan.find((item) => item.scan_data_type.id == 6)
                  //         .journey_stage
                  //     : scan.scan.find((item) => item.scan_data_type.id == 15)
                  //         .journey_stage
                  //   : scan.scan.find(
                  //       (item) =>
                  //         item.scan_data_type.id == scan.scan_data_type.id
                  //     )
                  //   ? scan.scan.find(
                  //       (item) =>
                  //         item.scan_data_type.id == scan.scan_data_type.id
                  //     ).journey_stage
                  //   : "-",
                  FirstName: isDeletedUser
                    ? "Deleted"
                    : scan.first_name
                      ? scan.first_name
                      : "-",
                  LastName: isDeletedUser
                    ? "User"
                    : scan.last_name
                      ? scan.last_name
                      : "-",
                  entity_id: scan.entity_id,
                  UserType:
                    scan.scan_data_type_id == 5 &&
                      scan.user_id.includes("undefined")
                      ? "Undefined"
                      : scan.user_type_name,
                  user_type:
                    scan && scan.scan && scan.scan[0] && scan.scan[0].user_type
                      ? scan.scan[0].user_type
                      : null,
                  Area: scan.area_name ? scan.area_name : "-",
                  area_id: scan.area_id,
                  site_id: scan.site_id,
                  ExpectedTime:
                    scan.scan_data_type_id == 5
                      ? "-"
                      : scan.expected_visit_time
                        ? moment.utc(scan.expected_visit_time).tz(userTimezone)
                        : scan.expected_visit_time,
                  ArrivalTime:
                    scan.signed_in
                      ? moment.utc(scan.signed_in).tz(userTimezone)
                      : "-",
                  Date: moment
                    .utc(scan.date)
                    .tz(userTimezone)
                    .format("YYYY-MM-DD"),
                  DepartureTime:
                    scan.scan_data_type_id == 5
                      ? "-"
                      : scan.signed_out
                        ? moment.utc(scan.signed_out).tz(userTimezone)
                        : "-",
                  Data: scan,
                  FullName: isDeletedUser
                    ? "Deleted User"
                    : scan.full_name
                      ? scan.full_name
                      : "-",
                  // if visit status is Expected (id = 6) and no comp filled in OR visit status is "No show" OR visit status is "Rejected" -> show site only
                  Site: scan.site_area
                    ? scan.site_area
                    : scan.site_name
                    ? scan.site_name
                    : "-",
                });
              });

              this.isServerSideExport = data.data.totalCount >= process.env.VUE_APP_EXPORT_LIST_COUNT;
              this.finalFilterObject = finalFilterObject;
              this.sortObject = sortObject ? sortObject : { sortField: null };
              this.totalCount = data.data.totalCount;
              // this.resetDashboardData();

              this.gridEmptyMessage = this.$t('common.grid.noRecordsYet');
              this.dataGrid.endCustomLoading();
              // console.log("dd", dd);
              return {
                data: dd,
                totalCount: data.data.totalCount,
                summary: data.data.summary,
                groupCount: data.data.groupCount,
              };
            })
            .catch((err) => {
              throw new Error(err);
            });
        },
        // eslint-disable-next-line no-unused-vars
        update: (key, values) => {
          // eslint-disable-next-line no-unused-vars
          const { updateUserAction } = this;
          const entity_id = store.getters["authfack/currentEntity"].id;
          const { FirstName, LastName } = values;

          // eslint-disable-next-line no-unused-vars
          const data = {
            entity_id,
            // user_user_id,
            first_name: FirstName,
            last_name: LastName,
            // email,
            // phone,
            // image,
            // rfid_number,
            // user_type_id,
            // system_user,
            // password,
          };
        },
      });
    },
    onItemContextMenu(e) {
      console.log('e', e);
      if (!e.items) e.items = [];
      const nodeData = e.row?.data;
      if (!nodeData || this.isSelectionMode ) return;
      let signInOut = ''
      if(this.checkPermissions(nodeData)){
        signInOut = `<div class="tooltip-container-signinout" style="width:100%" data-bs-toggle="tooltip" id="${nodeData.Data.id}-signinout-contextmenu" tabindex="${nodeData.Data.id}">${this.$t("common.signInOutUppercase")} <span class="tooltip-text-signinout">This action is only available on visit day</span></div>`
      }else{
        signInOut = `${this.$t("common.signInOutUppercase")}`
      }
      
      e.items.push(
        {
          visible : this.editingVisitId != nodeData.visit_id && !nodeData.user_id.includes('undefined') && nodeData.is_active,
          html: this.$t("dashboard.grid.editUser"),
          onItemClick: () => {
            this.startEdit(e);
          },
        },
        {
          visible : nodeData.is_active && !nodeData.user_id.includes('undefined'),
          html: signInOut,
          // disabled : this.checkPermissions(nodeData),
          onItemClick: (e) => {
            // console.log('e',e);
            if(!this.checkPermissions(nodeData)) this.openCheckInModal(nodeData);
            else e.preventDefault();
          },
        },
        {
          visible : true,
          html: this.$t("dashboard.grid.addVisitNotes"),
          onItemClick: () => {
            this.openVisitNotes( nodeData);
          },
        },
        {
          visible: nodeData.Data.isExpectedScanExist &&
                (nodeData.Data.expectedJourneyStageId ==
                  'waiting_for_admin_approval_compliance_failed' ||
                  nodeData.Data.expectedJourneyStageId == 'compliance_failed'),
          html: this.$t("dashboard.grid.resendCompliance"),
          onItemClick: () => {
            this.fullName = nodeData.FullName;
            this.visit_id = nodeData.visit_id;
            this.$bvModal.show('reloadCompliance');
          },
        },
        {
          visible : this.showManageVisitBtn(nodeData),
          html: this.$t("common.manageVisit"),
          onItemClick: () => {
            this.openCompModal(nodeData, true);
          },
        },
        {
          visible : nodeData.scan_data_type_id != 5 && this.isShowFillInComp(nodeData) && nodeData.is_active,
          html: this.$t("common.fillInCompliance"),
          class: "context-menu-items",
          onItemClick: () => {
            this.openCompModal(nodeData, false)
          },
        },
        {
          visible : nodeData.scan_data_type_id == 6 && nodeData.Data.isExpectedScanExist && nodeData.is_active,
          html: `${this.$t("common.edit")} ${this.$t("common.expectedVisit")}`,
          onItemClick: () => {
            this.editDeleteVisit(nodeData, 1);
          },
        },
        {
          visible : nodeData.scan_data_type_id == 6 && nodeData.Data.isExpectedScanExist && nodeData.is_active,
          html: `<span class="red-remove">${this.$t("common.delete")} ${this.$t("common.expectedVisit")}</span>`,
          onItemClick: () => {
            this.editDeleteVisit(nodeData, 0);
          },
        },
      );
    },

  //   onOptionChanged(e) {
  //     console.log('onOptionChanged', e);
  //   if (e.fullName?.startsWith("columns") && e.fullName.endsWith("filterValue")) {
  //     const value = e.value;

  //     // If it's a string filter (i.e., user is typing)
  //     if (typeof value === "string" && value.length < 3) {
  //       // Prevent triggering filter request by resetting filter value
  //       const grid = e.component;
  //       const columnIndex = parseInt(e.fullName.split(".")[1], 10);
  //       grid.columnOption(columnIndex, "filterValue", null);
  //     }
  //   }
  // },
    isShowFillInComp(data) {
      // console.log('isShowFillInComp', data);
      const expectedVisit = data.Data.isExpectedScanExist;
      // data.scan_data_type.id == 6;
      // console.log("expectedVisit", expectedVisit, data);
      if (
        expectedVisit &&
        (data.pre_registration_method == "REGISTRATION_ALLOWED" ||
          data.pre_registration_method == "PRE_REGISTERED_ONLY")
      ) {
        if (
          data.Data.expectedJourneyStageId == "compliance_pending" ||
          data.Data.expectedJourneyStageId == "compliance_failed" ||
          (data.Data.expectedJourneyStageId == "ready_to_sign_in" &&
            // data.scans.find(
            //   (item) =>
            //     item.scan_data_type.id == 13 || // compliance filled in status(13)
            //     (expectedVisit.metadata &&
            //       expectedVisit.metadata.checks &&
            //       expectedVisit.metadata.checks.length > 0) // all compliance is optional
            // ))
            data.Data.complianceFilledInMetadata &&
            data.Data.complianceFilledInMetadata.checks &&
            data.Data.complianceFilledInMetadata.checks.length > 0)
        )
          return true;
      }
      return false;
    },
    async editDeleteVisit(data, isEdit) {
      console.log("edit visit", data, isEdit);
      // await this.setData(JSON.stringify(data));
      this.selectedVisit = data;
      //   console.log("date0", this.dateValue, this.timeValue);
      setTimeout(async () => {
        if(isEdit) await this.$bvModal.show("edit_expected_visit_modal");
        else await this.$bvModal.show("delete_expected_visit_modal");
      }, 500);
    },
  },
  directives: {
    hide(el, binding) {
      el.style.display = binding.value ? "none" : "";
    },
  },
  mounted() {
    this.setPrintBadgeFromQuickSignIn({val: false, usersForPrint: null});
    this.$store.commit("preRegistration/setRefreshGrid", false);
    document.title = this.$t("sideNavbarMenu.dashboard.text");
    document.getElementById("preloader").style.display = "none";
    document.getElementById("status").style.display = "none";
    window.addEventListener("unload", this.resetFilterValues());

    const { resetSelectedRows, currentEntity } = this;
    if (currentEntity.setting && currentEntity.setting.length > 0) {
      currentEntity.setting.forEach((row) => {
        if (row.name == "temperature_display_unit_for_company") {
          this.selectedTempreture = row.pivot ? row.pivot.value : "c";
        }
      });
    }

    resetSelectedRows();
  },
  destroyed() {
    // this.resetTableHeaders();
    this.resetFilterValues();
    this.onResetModal();
  },
  async beforeMount() {
    if (this.getLanguage === "ar") {
      this.rtlEnabled = true;
      this.needUpdateScrollPosition = true;
    }

    this.userRole = this.getUserRole.name.toLowerCase();
    // console.log(this.userRole)
    this.showUserData =
      this.userRole != "employee" && this.userRole != "fire warden";

      // console.log('this.getDashboardData', this.getDashboardData);
    const res = await this.fetchDashboardData();
    this.dashboardData = res.data;

    this.setColumnAppearance();
    this.allLabels = this.dashboardData.labels;
    this.dashboardData.scanDataTypes.map((status) => {
      this.statusHeaderFilter.push({
        text: status.name,
        value: status.id,
      });
    });
    this.vaccineDocument = await this.dashboardData.documentTypes?.documents.length > 0;
    // this.userTypeHeaderFilter = await this.dashboardData.userTypes;
    await this.dashboardData.userTypesOneLevel.map((userType) => {
    this.userTypeHeaderFilter.push({
      text: userType.name,
      value: userType.id,
    });
  });
    this.areaHeaderFilter = await this.dashboardData.areas;

    // await this.getAllCustomFields();
    this.dailyLogCustomFields = await this.dashboardData.customFields;
    await this.dailyLogCustomFields.forEach(field => {
      if (field.type == "ratingScale" || field.type == "toggleButton") {
        this.allFilterHeaders.push(`Data.customFields.${field.id}`);
      }
    });
    this.renderDashboardGridData();
  },
};
</script>

<template>
  <div class="main-page-container">
    <!-- exporting -->
    <b-modal id="exportingProgress" hide-footer hide-header size="lg" :scrollable="false">
      <ExportProgress />
    </b-modal>

    <b-modal
      id="reloadCompliance"
      class="popover-modal"
      scrollable
      hide-header
      hide-footer
    >
      <div class="reload-compliance-modal-header">{{ $t("dashboard.grid.resendCompliance") }}</div>

      <div class="reload-compliance-modal-content">
        <p>
          {{ $t("common.notes.areYouSureYouWant") }} <b>"{{ $t("common.resend") }}"</b> {{ $t("complianceList.form.TheComplianceTo") }}
          {{ fullName }}{{ $t("common.questionMark") }}
        </p>
      </div>

      <hr />
      <div class="reload-compliance-modal-footer">
        <VpButton
          :text="$t('common.resend')"
          :isLoading="resendLoading"
          :disabled="resendLoading"
          @click="resendCompliance()"
        />
        <button class="cancel-btn" @click="$bvModal.hide('reloadCompliance')">
          {{ $t("common.cancel") }}
        </button>
      </div>
    </b-modal>

    <!-- dashboard compliances  -->
    <b-modal id="dashboardCompliances" hide-footer hide-header size="md" scrollable>
      <Compliances />
    </b-modal>

    <b-modal id="dashboardLocations" hide-footer hide-header size="lg" scrollable>
      <Locations />
    </b-modal>

    <!-- action modal -->
    <b-modal id="dashboardActionOne" scrollable hide-footer hide-header size="md">
      <UserCheckinAction :parentGrid="'dashboard'" @submitted="checkInSubmit" @printBadge="printBadge" />
    </b-modal>

    <PrintBadgeForm :selectedUsersForPrint="usersForPrint" />

    <!-- start::Acl error modals -->
    <AclErrorModals />
    <!-- end::Acl error modals -->

    <!-- Attendance Mode Denied Access -->
    <b-modal id="attendanceModeDeniedAccess" hide-footer size="lg" scrollable hide-header no-close-on-backdrop>
      <AttendanceModeDeniedAccess />
    </b-modal>

    <!-- Signin mass action -->
    <b-modal id="signinMassaction" hide-footer hide-header size="md" :scrollable="false">
      <MassactionIndex :selectedUsers="selectedRowsData" />
    </b-modal>

    <!-- vaccine details  -->
    <b-modal id="vaccineDetailsModal" class="popover-modal" hide-header hide-footer no-close-on-esc :scrollable="true"
      ref="vaccineDetailsModal">
      <VaccineDetails />
    </b-modal>

    <!-- Fill in Compliance & Manage Visit -->
    <b-modal
      id="visit_modal"
      scrollable
      hide-header
      hide-footer
      no-close-on-esc
      ref="visit_modal"
    >
      <div
        :class="{
          'modal-topheader-left': getApproveVisit || getRejectVisit,
          'modal-topheader': !getApproveVisit && !getRejectVisit,
        }"
      >
        <div class="modal-toptitle">
          <p :class="{
            'modal-title-left': getApproveVisit || getRejectVisit,
            'modal-title': !getApproveVisit && !getRejectVisit,
          }">
            {{ visitModalTitle }}
          </p>

          <svg
            style="position: absolute; top: 32px; inset-inline-end: 32px; cursor: pointer"
            @click="hideModal('visit_modal')"
            width="22"
            height="22"
            viewBox="0 0 22 22"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M11 0C4.91333 0 0 4.91333 0 11C0 17.0867 4.91333 22 11 22C17.0867 22 22 17.0867 22 11C22 4.91333 17.0867 0 11 0ZM16.5978 14.7156C17.1111 15.2289 17.1111 16.06 16.5978 16.5733C16.3289 16.8422 16.0111 16.9644 15.6689 16.9644C15.3267 16.9644 14.9844 16.8422 14.74 16.5733L11.0733 12.9067L7.38222 16.5733C7.11333 16.8422 6.79556 16.9644 6.45333 16.9644C6.11111 16.9644 5.76889 16.8422 5.52444 16.5733C5.01111 16.06 5.01111 15.2289 5.52444 14.7156L9.21556 11.0244L5.52444 7.35778C5.01111 6.84444 5.01111 6.01333 5.52444 5.5C6.03778 4.98667 6.86889 4.98667 7.38222 5.5L11.0733 9.19111L14.7644 5.5C15.2778 4.98667 16.1089 4.98667 16.6222 5.5C17.1356 6.01333 17.1356 6.84444 16.6222 7.35778L12.9311 11.0489L16.5978 14.7156Z"
              fill="#F46A6A" />
          </svg>
        </div>
      </div>
      <ComplianceFillIn :modalId="'visit_modal'" :modalLoading="modalLoading" :firstName="firstName"
        :lastName="lastName" :id="id" :visitId="visitId" :manageVisit="manageVisit" :visitRejected="visitRejected"
        :visitApproved="visitApproved" :scan_time="scan_time" :action_by="action_by" :rejectionReason="rejectionReason"
        :userTypeId="userTypeId" :areaId="areaId" :onlineCompliance="false" :visitModalTitle="visitModalTitle" />
    </b-modal>

    <b-modal
      id="UpdateScanCustomFieldsModal"
      scrollable
      hide-header
      hide-footer
      no-close-on-esc
      ref="UpdateScanCustomFieldsModal"
    >
      <UpdateScanCustomFieldsModal @refreshGrid="refreshGrid" />
    </b-modal>

    <b-modal id="quickSignIn" scrollable hide-header hide-footer>
      <QuickSignIn @submitted="checkInSubmit" @printBadge="printBadge" />
    </b-modal>
    <AlertFoundActiveSession />

    <PageHeader
      :title="$t('sideNavbarMenu.dashboard.text')"
      :hasHeaderButton="true"
      class="page-top-header d-flex align-items-center vp-width-270"
    >
      <template #headerButton>
        <button class="cursor-pointer" @click="$bvModal.show('quickSignIn')">
          {{ $t("users.form.quickSignin") }}
        </button>
      </template>
    </PageHeader>

    <div class="row">
      <div class="col-xl-4"></div>
    </div>

    <!-- add visit notes modal -->
         <!-- edit expected visit -->
    <b-modal id="add_visit_notes_modal"
      scrollable
      hide-header
      hide-footer
      no-close-on-esc
      ref="add_visit_notes_modal"
    >
      <addVisitNotesModal :dailyLogData="selectedVisit" :modalIdType="'string'"/>
    </b-modal>

    <!-- edit expected visit -->
    <b-modal  id="edit_expected_visit_modal"
    scrollable
    hide-header
    hide-footer
    no-close-on-esc
    ref="edit_expected_visit_modal"
    >
      <editExpectedVisitModal :dailyLogData="selectedVisit" :modalIdType="'string'"/>
    </b-modal>

    <!-- delete expected visit -->
    <b-modal  id="delete_expected_visit_modal"
    scrollable
    hide-header
    hide-footer
    no-close-on-esc
    ref="delete_expected_visit_modal"
    >
      <deleteExpectedVisitModal :dailyLogData="selectedVisit" :modalIdType="'string'"/>
    </b-modal>

    <!-- grid -->
    <section
      class="dashboard-white-bg-sec dashboard-grid"
      :class="{ 'hide-loader': hideLoader }"
    >


      <DxDataGrid
        id="gridContainer"
        :rtl-enabled="rtlEnabled"
        :class="{
          dashboardGridHeightWithAlert: getActiveSessionsCount,
          dashboardGridHeight: !getActiveSessionsCount,
        }"
        :ref="dataGridRef"
        :data-source="dataStore"
        :no-data-text="gridEmptyMessage"
        :remote-operations="true"
        :showBorders="false"
        :columnAutoWidth="true"
        :allowColumnReordering="true"
        :allowColumnResizing="true"
        :rowAlternationEnabled="false"
        :showColumnLines="true"
        :showRowLines="true"
        :repaint-changes-only="true"
        :selected-row-keys="selectedRowKeys"
        @editing-start="start($event)"
        @edit-canceling="isEdit = false"
        @edit-canceled="
          isEdit = false;
        editingVisitId = null;
        " @saved="
          isEdit = false;
          editingVisitId = null;
        "
        @row-updated="updateRow($event)"
        @content-ready="contentReady($event)"
        @editor-preparing="onEditorPreparing($event)"
        @row-prepared="onRowPrepared($event)"
        @initialized="onInitialized($event)"
        @selection-changed="onSelectionChanged"
        @cell-prepared="onCellPrepared"
        :selectedRowKeys.sync="selectedRows"
        @focused-row-changed="focusChanged"
        :columns="dailyLogGridColumns"
        @data-error-occurred="onDataErrorOccurred($event)"
        column-resizing-mode="widget"
        @context-menu-preparing="onItemContextMenu"
        key-expr="visit_id"
      >
        <DxScrolling mode="standard" :scroll-by-content="rtlEnabled" :use-native="!rtlEnabled" />
        <DxEditing
          :use-icons="false"
          :allow-updating="true"
          :allow-adding="false"
          :allow-deleting="false"
          mode="row"
        />

        <DxStateStoring :enabled="true" type="custom" :customLoad="customLoad" :customSave="customSave"
          storage-key="dashboardGrid" />

        <DxPaging :page-size="50" />
        <DxPager
          :visible="true"
          :allowed-page-sizes="[5, 10, 25, 50, 100]"
          :display-mode="'full'"
          :show-page-size-selector="true"
          :show-info="true"
          :show-navigation-buttons="true"
          :infoText="rtlEnabled ?  'صفحة {0} من {1} ({2} إجمالي العناصر)' : ''"
        />

        <DxSelection mode="multiple" :select-all-mode="'page'" />

        <DxFilterRow :visible="true" />
        <!-- <DxFilterRow :visible="true" :apply-filter="currentFilter"/> -->

        <DxHeaderFilter :visible="true" />

        <!-- <DxSearchPanel :visible="true" placeholder="Search..."/> -->

        <DxColumnChooser
          :enabled="true"
          mode="select"
          :title="$t('common.grid.columnChooser')"
        />

        <!-- <DxGrouping :context-menu-enabled="true"/>
      <DxGroupPanel :visible="true"/> -->

        <DxExport :enabled="true" :allow-export-selected-data="false" />

        <DxToolbar v-show="!isSelectionMode">
          <!-- <DxItem name="groupPanel"/> -->
          <DxItem template="columnButtonTemplate" location="before" />
          <DxItem template="exportButtonTemplate" location="before" />
          <DxItem template="dateFilterTemplate" location="before" />
          <DxItem template="clearAllTemplate" location="before" />
          <DxItem template="tempUnitsTemplate" location="after" />
          <!-- <DxItem template="exportCSVTemplate"/>
        <DxItem template="exportExcelTemplate"/>
        <DxItem template="exportPDFTemplate"/> -->
          <!-- <DxItem name="searchPanel"/> -->
        </DxToolbar>

        <!-- Toobar for tablet mode -->
        <DxToolbar v-if="isSelectionMode && breakpoints.lg">
          <DxItem template="visitsSelectedCount" location="before" />
          <DxItem template="massactionsDDL" location="before" />
        </DxToolbar>

        <DxToolbar v-else-if="isSelectionMode && !breakpoints.lg">
          <DxItem template="clearAllTemplate" location="before" />
          <DxItem template="visitsSelectedCount" location="before" />
          <!-- <DxItem
            v-if="commonActions && commonActions.includes('Manage visit')"
            template="manageVisitTemplate"
            location="before"
          />
          <DxItem
            v-if="commonActions && commonActions.includes('Approve')"
            template="approveTemplate"
            location="before"
          />
          <DxItem
            v-if="commonActions && commonActions.includes('Reject')"
            template="rejectTemplate"
            location="before"
          />
          <DxItem
            v-if="
              commonActions &&
              (commonActions.includes('Manage visit') ||
                commonActions.includes('Approve') ||
                commonActions.includes('Reject'))
            "
            template="lineTemplate"
            location="before"
          /> -->
          <!-- <DxItem
            v-if="commonActions.includes('Edit')"
            template="editTemplate"
            location="before"
          />
          <DxItem
            v-if="commonActions.includes('Delete')"
            template="deleteTemplate"
            location="before"
          /> -->
          <!-- <DxItem
            v-if="
              commonActions &&
              (commonActions.includes('Edit') ||
                commonActions.includes('Delete'))
            "
            template="lineTemplate"
            location="before"
          /> -->
          <!-- <DxItem
            v-if="commonActions && commonActions.includes('Resend compliance')"
            template="resendComplianceTemplate"
            location="before"
          /> -->
          <!-- <DxItem
            v-if="commonActions && commonActions.includes('Resend compliance')"
            template="lineTemplate"
            location="before"
          /> -->
          <DxItem v-if="commonActions && commonActions.includes('Sign in/out')" template="signInOutTemplate"
            location="before" />
        </DxToolbar>

        <template #journeyStage-cell="{ data }">
          <div>
            {{ data.data.CurrentJourneyStage }}
            <!-- <pre>{{ Object.keys(data.data.scans[0]) }}</pre> -->
            <!-- <pre>{{ data.data.scans[0].scan_data_type.id }}</pre> -->
            <!-- data.data.scan_data_type_id == 6 -->
            <!-- <pre>{{ data.data.scans.find( scan => scan.scan_data_type.id == '6') }}</pre> -->
            <button
              :disabled="isSelectionMode"
              class="resend-compliance-btn"
              v-if="
                data.data.Data.isExpectedScanExist &&
                (data.data.Data.expectedJourneyStageId ==
                  'waiting_for_admin_approval_compliance_failed' ||
                  data.data.Data.expectedJourneyStageId == 'compliance_failed')
              "
              @click="
                fullName = data.data.FullName;
                visit_id = data.data.visit_id;
                $bvModal.show('reloadCompliance');
              "
            >
              <i class="mdi mdi-refresh refresh-icon"> </i>
            </button>
          </div>
        </template>

        <template #rfid-template="{ data }">
          {{
            data.data.scan_data_type_id == 5 &&
              data.data.user_id.includes("undefined")
              ? "-"
              : data.data.RFID
                ? rfidFormatter(data.data.RFID)
                : "-"
          }}
        </template>

        <template #user-edit-template="{ data }">
          <div>
            <p v-if="
              (data.data.scan_data_type_id == 5 &&
                data.data.user_id.includes('undefined')) ||
              !data.data.hasPermissionOnProfileUserType
            ">
              -
            </p>

            <template
              v-else-if="
                editingVisitId == data.data.visit_id &&
                !data.data.user_id.includes('undefined')
              "
            >
              <button
                class="save-user-button cursor-pointer"
                @click="saveRow(data)"
              >
                {{ $t("common.save") }}
              </button>
              <button
                class="cancel-user-button cursor-pointer"
                @click="cancelEdit(data)"
              >
                {{ $t("common.cancel") }}
              </button>
            </template>
            <template
              v-else-if="
                editingVisitId != data.data.visit_id &&
                !data.data.user_id.includes('undefined')
              "
            >
              <button
                class="edit-user-button cursor-pointer"
                :disabled="isSelectionMode"
                @click="startEdit(data)"
              >
                {{ $t("dashboard.grid.editUser") }}
              </button>
            </template>
          </div>
        </template>

        <DxMasterDetail :enabled="true" template="master-detail" />
        <template #master-detail="{ data }">
          <div>
            <h5 class="master-detail-caption text-dark">
              {{ $t("dashboard.grid.visitHistory") }}
            </h5>
            <!-- <DxScrollView direction="horizontal" :use-native="true"> -->

            <MasterDetailGrid
              :visit="data.data.Data"
              :isDeletedUser="data.data.isDeletedUser"
              :isArchivedUser="data.data.is_archived"
              :selectedTemp="selectedTempreture"
              @setUpdateScroll="setUpdateScroll"
            />

            <!-- </DxScrollView> -->
          </div>
        </template>

        <template #image-cell="{ data }">
          <div v-viewer class="images dash-img clearfix">
            <ImageCell v-if="!data.data.Image" :image="data.data.Image"
              :name="data.data.FirstName ? data.data.FirstName.charAt(0) : ''" />
            <img class="img-fluid rounded-circle" v-if="data.data.Image" style="cursor: pointer"
              :src="data.data.Image" />
          </div>
        </template>

        <template #visitsSelectedCount>
          <p class="toolbar-users-counter">
            {{ noOfSelectedRows }}
            {{ noOfSelectedRows > 1 ? $t("common.visits") : $t("common.visit") }} {{ $t("common.selected") }}
          </p>
        </template>

        <template #manageVisitTemplate>
          <button class="toolbar-action-buttons toolbar-primary cursor-pointer">
            <span class="custom-text">{{ $t("common.manageVisit") }}</span>
          </button>
        </template>

        <template #approveTemplate>
          <button class="toolbar-action-buttons toolbar-success cursor-pointer">
            <span class="custom-text">{{ $t("common.approve") }}</span>
          </button>
        </template>

        <template #rejectTemplate>
          <div class="d-flex justify-content-between align-items-center">
            <button class="toolbar-action-buttons toolbar-alert cursor-pointer">
              <span class="custom-text">{{ $t("common.reject") }}</span>
            </button>
          </div>
        </template>

        <template #editTemplate>
          <button class="toolbar-action-buttons toolbar-main cursor-pointer">
            <span class="custom-text">{{ $t("common.edit") }}</span>
          </button>
        </template>

        <template #deleteTemplate>
          <div class="d-flex justify-content-between align-items-center">
            <button class="toolbar-action-buttons toolbar-alert cursor-pointer">
              <span class="custom-text">{{ $t("common.delete") }}</span>
            </button>
          </div>
        </template>

        <template #resendComplianceTemplate>
          <div class="d-flex justify-content-between align-items-center">
            <button class="toolbar-action-buttons toolbar-main cursor-pointer">
              <span class="custom-text">{{
                $t("dashboard.grid.resendCompliance")
              }}</span>
            </button>
          </div>
        </template>

        <template #signInOutTemplate>
          <button v-b-modal="'signinMassaction'" class="toolbar-action-buttons toolbar-primary cursor-pointer">
            <span class="custom-text">{{ $t("common.signInOut") }}</span>
          </button>
        </template>

        <template #lineTemplate>
          <div class="v-line"></div>
        </template>

        <template #tempUnitsTemplate>
          <div
            class="d-flex align-items-center"
            style="height: 20px; padding-inline-end: 24px"
          >
            <label class="mb-0 custom-temp-unit vp-mr-24" for="radio-slots">{{
              $t("common.temperatureUnit")
            }}</label>
            <div style="height: 20px">
              <v-radio-group v-model="selectedTempreture">
                <v-radio
                  v-for="option in options"
                  :key="option.value"
                  :label="option.text"
                  :value="option.value"
                ></v-radio>
              </v-radio-group>
            </div>
          </div>
        </template>

        <template #clearAllTemplate>
          <div v-if="showClearAll" class="clear-cols d-flex align-items-center">
            <!-- 'Clear All' button style for tablet mode -->
            <template v-if="breakpoints.lg">
              <Button
                :text="$t('common.grid.clearFilters')"
                @click="reset()"
                styling-mode="outlined"
                class="clear-CustomColums vp-ml-0 cursor-pointer"
                :class="{
                  'first-clear': isSelectionMode,
                }"
                type="danger"
              />
            </template>
            <template v-else>
              <div v-if="!isSelectionMode" class="toolbar-custom-line"></div>
              <Button
                :text="$t('common.grid.clearFilters')"
                @click="reset()"
                styling-mode="outlined"
                :class="{
                  'first-clear': isSelectionMode,
                }"
                :style="{
                  'margin-inline-start': isSelectionMode ? '24px' : '0px',
                }"
                type="danger"
                class="clear-CustomColums cursor-pointer"
              />
              <div
                v-if="isSelectionMode"
                class="v-line"
                style="
                  height: 75px;
                  margin-inline-start: 24px !important;
                  margin-inline-end: 0px !important;
                "
              ></div>
            </template>
          </div>
        </template>

        <!-- DDL for mass action when tablet mode -->
        <template #massactionsDDL>
          <DxDropDownButton
            class="massaction-ddl"
            text="Mass actions"
            :drop-down-options="{ width: 130 }"
            :items="massactionItems"
            itemTemplate="massactionItemTemplate"
          >
            <template #massactionItemTemplate="{ data }">
              <div class="massaction-item" v-b-modal="data.modalId">
                <span>{{ data.text }}</span>
              </div>
            </template>
          </DxDropDownButton>
        </template>

        <template #dateFilterTemplate>
          <div>
            <div
              class="d-flex filter-input align-items-center justify-content-center"
            >
              <div class="datee mx-1">
                <date-picker
                  range
                  append-to-body
                  :lang="{
                    formatLocale: {
                      firstDayOfWeek: 1,
                    },
                    monthBeforeYear: true,
                  }"
                  value-type="YYYY-MM-DD"
                  format="DD/MM/YYYY"
                  placeholder="Filter by date"
                  :clearable="false"
                  range-separator=""
                  ref="datePick"
                  :class="{
                    'date-noDataWidth': !dateRange[0],
                    'date-dataWidth': !!dateRange[0],
                  }" v-model="dateRangeLocal" @change="dateChanged()" @open="selectedDate = null"
                  @pick="pickDate($event)" :disabled-date="disableDate">
                  <i slot="icon-calendar" class="mdi mdi-calendar"> </i>
                </date-picker>
              </div>
              <div class="center-icon d-flex h-30">
                <div
                  class="date-close-style d-flex align-items-center vp-ml-8"
                  v-if="dateRange && checkDate"
                  @click="resetDate()"
                >
                  <svg
                    style="cursor: pointer"
                    width="22"
                    height="22"
                    viewBox="0 0 22 22"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M11 0C4.91333 0 0 4.91333 0 11C0 17.0867 4.91333 22 11 22C17.0867 22 22 17.0867 22 11C22 4.91333 17.0867 0 11 0ZM16.5978 14.7156C17.1111 15.2289 17.1111 16.06 16.5978 16.5733C16.3289 16.8422 16.0111 16.9644 15.6689 16.9644C15.3267 16.9644 14.9844 16.8422 14.74 16.5733L11.0733 12.9067L7.38222 16.5733C7.11333 16.8422 6.79556 16.9644 6.45333 16.9644C6.11111 16.9644 5.76889 16.8422 5.52444 16.5733C5.01111 16.06 5.01111 15.2289 5.52444 14.7156L9.21556 11.0244L5.52444 7.35778C5.01111 6.84444 5.01111 6.01333 5.52444 5.5C6.03778 4.98667 6.86889 4.98667 7.38222 5.5L11.0733 9.19111L14.7644 5.5C15.2778 4.98667 16.1089 4.98667 16.6222 5.5C17.1356 6.01333 17.1356 6.84444 16.6222 7.35778L12.9311 11.0489L16.5978 14.7156Z"
                      fill="#F46A6A"
                    />
                  </svg>
                </div>
              </div>
            </div>
          </div>
        </template>

        <template #exportButtonTemplate>
          <DxDropDownButton class="export-dropdown" :items="buttonData" :text="$t('common.grid.export')"
            @item-click="serverSideExport" />

          <!-- <DxDropDownButton
            :items="buttonData"
            text="Export"
            @item-click="onItemClick"
            v-else
          /> -->
        </template>

        <template #columnButtonTemplate>
          <button class="custom-columns" @click="dataGrid.showColumnChooser()">
            <span class="custom-text">{{ $t("common.grid.columns") }} </span>

            <span class="custom-icon">
              <i class="dx-icon dx-icon-spindown dx-icon-right"></i>
            </span>
          </button>
        </template>

        <template #status-cell="{ data }">
          <!-- <StatusCell :status="data.data.Status" :data="data.data.Data" /> -->

          <div v-if="
            data.data.scan_data_type_id == 4 ||
            data.data.scan_data_type_id == 5 ||
            data.data.scan_data_type_id == 8 ||
            data.data.scan_data_type_id == 16 || // REJECTED
            data.data.scan_data_type_id == 17 // DELETED
          ">
            <span class="text-red font-weight-bolder">{{
              data.data.scan_data_type_name
              }}</span>
          </div>

          <!-- EXPECTED VISIT STATUS -->
          <div v-else-if="data.data.scan_data_type_id == 6">
            <span class="text-warning font-weight-bolder">{{
              data.data.scan_data_type_name
              }}</span>
          </div>

          <!-- NO SHOW VISIT STATUS -->
          <div v-else-if="data.data.scan_data_type_id == 7">
            <span style="font-weight: 700; font-size: 16px; color: #000000">{{
              data.data.scan_data_type_name
              }}</span>
          </div>

          <!-- ADDED AS EXPECTED STATUS -->
          <div v-else-if="data.data.scan_data_type_id == 11">
            <span>{{ data.data.scan_data_type_name }}</span>
          </div>

          <div v-else class="text-green font-weight-bolder">
            {{ data.data.scan_data_type_name }}
          </div>
        </template>

        <template #site-cell="{ data }">
          <div>
            <span>{{ data.value }}</span>
            <svg
              v-if="data.data.Data.full_path"
              tabindex="0"
              v-b-tooltip
              :id="data.data.visit_id"
              style="margin-inline-start: 8px; outline: none"
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M7.9991 5.09274e-08C6.41689 0.00017857 4.87027 0.469523 3.55479 1.34868C2.23932 2.22784 1.21408 3.47734 0.608721 4.93916C0.00335938 6.40099 -0.154957 8.00949 0.153826 9.56128C0.46261 11.1131 1.2246 12.5384 2.34346 13.6572C3.46231 14.7759 4.88778 15.5377 6.43961 15.8463C7.99143 16.155 9.59991 15.9965 11.0617 15.391C12.5234 14.7854 13.7728 13.76 14.6518 12.4445C15.5308 11.1289 16 9.58221 16 8C16 6.94935 15.793 5.90899 15.3909 4.93832C14.9888 3.96766 14.3995 3.0857 13.6565 2.34282C12.9136 1.59994 12.0315 1.01068 11.0608 0.608699C10.0901 0.206714 9.04974 -0.000118493 7.9991 5.09274e-08ZM9.04524 12.1855C9.04524 12.463 8.93503 12.729 8.73884 12.9252C8.54265 13.1214 8.27655 13.2316 7.9991 13.2316C7.72164 13.2316 7.45554 13.1214 7.25935 12.9252C7.06316 12.729 6.95295 12.463 6.95295 12.1855V7.22104C6.95295 6.94358 7.06316 6.67748 7.25935 6.48129C7.45554 6.2851 7.72164 6.17488 7.9991 6.17488C8.27655 6.17488 8.54265 6.2851 8.73884 6.48129C8.93503 6.67748 9.04524 6.94358 9.04524 7.22104V12.1855ZM7.9991 4.86337C7.79271 4.86283 7.59111 4.8012 7.41969 4.68626C7.24828 4.57132 7.11472 4.40821 7.03587 4.21748C6.95701 4.02676 6.93639 3.81696 6.97659 3.61453C7.01679 3.4121 7.11602 3.2261 7.26177 3.07998C7.40752 2.93386 7.59326 2.83414 7.79559 2.79342C7.99791 2.7527 8.20775 2.77279 8.39868 2.85116C8.58961 2.92952 8.75307 3.06264 8.86845 3.23376C8.98383 3.40487 9.04599 3.60633 9.04706 3.81271C9.04765 3.95058 9.02095 4.0872 8.96852 4.21471C8.91609 4.34223 8.83895 4.4581 8.74154 4.55568C8.64414 4.65325 8.52839 4.7306 8.40096 4.78325C8.27354 4.8359 8.13697 4.86282 7.9991 4.86246V4.86337Z"
                fill="#787878"
              />
            </svg>
            <b-tooltip
              placement="bottomright"
              :target="data.data.visit_id"
              triggers="click blur"
              v-if="data.data.Data.full_path"
            >
              {{ data.data.Data.full_path }}
            </b-tooltip>
          </div>
        </template>

        <template #departure-cell="{ data }">
          {{ data.data.DepartureTime ? data.data.DepartureTime : "-" }}
        </template>

        <template #visit-notes-cell="{ data }">
          <div style="
              white-space: normal;
              overflow-wrap: break-word;
              height: 90;
              width: 90;
            ">
            {{ data.value }}

            <a
              class="read_more"
              style="cursor: pointer"
              v-if="
                data.data.originalVisitNotes &&
                data.data.originalVisitNotes.length > 37 &&
                data.data.originalVisitNotes !== '-'
              "
              @click="changeFullText(data.data, false)"
            >
              {{ $t("dashboard.grid.read") }}
              {{
                data.data.showingFullText
                  ? $t("dashboard.grid.less")
                  : $t("dashboard.grid.more")
              }}
            </a>
          </div>
        </template>

        <template #action-cell="{ data }">
          <div class="d-flex align-items-center">
            <div class="text-center" style="display: none">
              <ActionCell :status="checkInStatus" :data="checkInData" id="checkInUser" ref="checkInUser" />
              <!-- <DxButton icon="fas fa-edit font-16 mr-2" name="edit"> </DxButton> -->
              <!-- <DxColumn icon="fas fa-edit font-16 mr-2" name="edit" [onClick]="editOrderItem">
                    </DxColumn> -->
            </div>

            <Actions :isSelectionModeEnabled="isSelectionMode" :dailyLogData="data.data"
              @onSetVisitData="setVisitData" />

            <button v-if="showManageVisitBtn(data.data)" class="custom-managevisit custom-action-grid"
              :disabled="isSelectionMode" @click="openCompModal(data.data, true)">
              {{ $t("common.manageVisit") }}
            </button>

            <template v-if="
              data.data.is_active &&
              !data.data.isDeletedUser &&
              !data.data.user_id.includes('undefined')
            ">
              <div v-b-tooltip.hover :id="data.data.Data.id + 'signinout'" :tabindex="data.data.Data.id">
                <button v-if="!cantEnterArea(data.data)" :disabled="isSelectionMode || checkPermissions(data.data)"
                  class="custom-signinout d-flex align-items-center justify-content-center custom-action-grid"
                  @click="openCheckInModal(data.data)"
                >
                  {{ $t("common.signInOut") }}
                </button>
              </div>

              <b-tooltip v-if="checkPermissions(data.data)" placement="bottomright"
                :target="data.data.Data.id + 'signinout'" triggers="hover blur">
                {{ "The action is available on visit day" }}
              </b-tooltip>

              <b-tooltip
               v-if="checkPermissions(data.data)"
                placement="bottomright"
                :target="data.data.Data.id+'-signinout-contextmenu'"
                triggers="hover blur"
              >
              {{ "The action is available on visit day" }}
            </b-tooltip>

            </template>
          </div>
        </template>

        <template #labels-template="{ data }">
          <div
            class="rating-label-container"
            v-if="data.value && !data.data.is_default_user"
            style="position: relative"
          >
            <span
              class="rating-label"
              :style="{ marginInlineStart: data.value > 9 ? '24%' : '36%' }"
              >{{ Number(data.value) }}</span
            >
          </div>
          <span v-else>-</span>
        </template>

        <template #stars-template="{ data }">
          <div
            v-if="data.value && !data.data.is_default_user"
            style="position: relative; width: 24px"
          >
            <svg
              width="24"
              height="24"
              viewBox="0 0 30 30"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M15 25.4465L6.993 29.8547C6.13663 30.3242 5.13656 29.5678 5.29908 28.5701L6.83048 19.2321L0.354854 12.6197C-0.338965 11.9155 0.0423195 10.683 0.998661 10.5395L9.9495 9.17663L13.9561 0.679814C14.3812 -0.226605 15.6188 -0.226605 16.0501 0.679814L20.0505 9.17663L29.0013 10.5395C29.9577 10.683 30.3389 11.9155 29.6452 12.6197L23.1695 19.2321L24.701 28.5701C24.8634 29.5678 23.8634 30.3308 23.007 29.8547L15 25.4465Z"
                fill="#103F5E"
              />
            </svg>
            <span
              class="rating-star"
              :style="{ insetInlineStart: data.value > 9 ? '23%' : '36%' }"
              >{{ Number(data.value) }}</span
            >
          </div>
          <span v-else>-</span>
        </template>

        <template #smileys-template="{ data }">
          <div
            v-if="data.value && !data.data.is_default_user"
            class="d-flex align-items-center"
            style="gap: 8px"
          >
            <div class="grid-smiley-container">
              <div class="d-flex align-items-center">
                <span
                  class="svg-div"
                  v-html="getRatingScaleData(data).smileySvg"
                ></span>
              </div>
            </div>
            <p
              class="smiley-text"
              :style="{ color: getRatingScaleData(data).smileyColor }"
            >
              {{ getRatingScaleData(data).smileyText }}
            </p>
          </div>
          <span v-else>-</span>
        </template>

        <template #checkboxes-template="{ data }">
          <span v-if="data.value && !data.data.is_default_user">{{
            getCheckboxVal(data.value)
          }}</span>
          <span v-else>-</span>
        </template>

        <template #date-template="{ data }">
          <span v-if="data.value && !data.data.is_default_user">{{
            data.value
          }}</span>
          <span v-else>-</span>
        </template>

        <template #toggle-template="{ data }">
          <span v-if="data.value && !data.data.is_default_user">{{
            +data.value ? "Yes" : "No"
          }}</span>
          <span v-else>-</span>
        </template>

        <template #dailyLogCustomField-template="{ data }">
          <span v-if="data.value && !data.data.is_default_user">{{
            data.value
          }}</span>
          <span v-else>-</span>
        </template>

        <template #default-template="{ data }">
          <span v-if="data.value">{{ data.value }}</span>
          <span v-else>-</span>
        </template>
      </DxDataGrid>

 
    </section>

  </div>
</template>

<style lang="scss" scoped>
.rating-star {
  position: absolute;
  top: 15%;
  margin: auto;
  color: white;
  font-size: 10px;
}

.rating-label-container {
  background-color: #103f5e;
  width: 24px;
  height: 24px;
  border-radius: 50%;
}

.rating-label {
  position: absolute;
  top: 12%;
  margin: auto;
  color: white;
  font-size: 10px;
}

.refresh-icon {
  background-color: #103f5e;
  border-radius: 50%;
  color: white;
}

.edit-user-button {
  color: #fff !important;
  background-color: #103f5e !important;
  border-color: #103f5e !important;
  width: 116px !important;
  height: 27px !important;
  border-radius: 4px;
}

.edit-user-button:disabled {
  opacity: 0.4;
}

.save-user-button {
  background: #34c38f;
  border-radius: 4px;
  width: 54px !important;
  height: 27 !important;
  color: #fff !important;
  margin-inline-end: 14px !important;
  border: none;
}

.cancel-user-button {
  background: none;
  color: #f46a6a !important;
  border: none;
}

.mdi-refresh::before {
  width: 18px;
  height: 18px;
  margin-inline-start: 1.5px;
  display: inline-flex;
}

.reload-compliance-modal-header {
  font-weight: 700;

  font-size: 17px;
  line-height: 20.4px;
  margin-bottom: 50px;
}

.reload-compliance-modal-content {
  font-weight: 400;
  min-width: 400px;

  font-size: 20px;
  text-align: center;
  color: #787878;
  opacity: 0.9;
  margin-bottom: 60px;
}

.reload-compliance-modal-content b {
  font-weight: 700;
  color: #868686;
  opacity: 1;
}

.reload-compliance-modal-footer {
  width: 250px;
  margin: auto;
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
}

.reload-compliance-modal-footer button {
  border: 0px;
  border-radius: 25px;
  width: 110px;
  height: 33px;

  font-weight: 400;
  font-size: 16px;
  line-height: 19.2px;
}

.reload-compliance-modal-footer .resend-btn {
  background-color: #103f5e;
  color: #ffffff;
}

.reload-compliance-modal-footer .cancel-btn {
  color: #f46a6a;
  background-color: #ffffff;
  border: 1px solid #f46a6a;
}

.action-padding {
  padding-bottom: 12px;
}

.custom-selectWidth {
  width: 142px !important;
  height: 27px !important;
}

.read_more {
  width: 69px;
  height: 17px;

  font-weight: 700;
  font-size: 14px;
  line-height: 17px;
  text-decoration-line: underline;
  color: #2680eb;
}

.visitNotesText {
  inset-inline-start: 32.99%;
  inset-inline-end: 33.12%;
  top: 42.67%;
  bottom: 43.56%;
  background-color: #f2f2f2;
  border-color: #f2f2f2;
  border-radius: 4px;
}

// counts
.scan-box {
  flex: 0 0 121px;
  height: 96px;
  background-color: #ffffff;
  border-radius: 8px;
  padding: 0.875rem;
  margin-bottom: 1%;
  -webkit-box-shadow: 1px 13px 12px 6px rgba(242, 242, 242, 0.98);
  box-shadow: 1px 13px 12px 6px rgba(242, 242, 242, 0.98);

  .scan-info {
    .scan-item {
      font-weight: 900;
      line-height: 12px;
      text-transform: uppercase;
      color: #c7c7c7;
      // font-size: 0.625;
      font-size: 10px;
      text-align: center;

      @media only screen and (max-width: 1120px) {
        font-size: 0.7rem;
      }

      @media only screen and (max-width: 768px) {
        width: 100%;

        .scan-item {
          font-size: 0.6rem;
        }
      }
    }

    .scan-item-user {
      font-weight: 900;
      line-height: 12px;
      color: #000000;
      opacity: 0.2;
      font-size: 10px;
      text-align: center;

      @media only screen and (max-width: 1120px) {
        font-size: 0.7rem;
      }

      @media only screen and (max-width: 768px) {
        width: 100%;

        .scan-item-user {
          font-size: 0.6rem;
        }
      }
    }

    .scan-item-two {
      font-weight: 900;
      font-size: 30px;
      line-height: 36px;
      color: #103f5e;

      @media only screen and (max-width: 1120px) {
        font-size: 1.25rem;
      }

      @media only screen and (max-width: 768px) {
        width: 100%;

        .scan-item-two {
          font-size: 0.625rem;
        }
      }
    }
  }

  .icon-wrapper {
    background-color: #103f5e;
    width: 25px;
    height: 25px;
    line-height: 25px;
    border-radius: 50%;
    text-align: center;

    i {
      color: #fff;
      font-size: 1rem;
    }

    @media only screen and (max-width: 1120px) {
      width: 20px;
      height: 20px;
      line-height: 20px;

      i {
        color: #fff;
        font-size: 0.7rem;
      }
    }
  }
}

.visible-icon {
  font-size: 2rem;
  color: #103f5e;
  transition: 0.3s;
  cursor: pointer;

  &:hover {
    color: aquamarine;
  }
}

.clear-icon {
  font-size: 1.1rem;
  transition: 0.3s;
  cursor: pointer;

  &:hover {
    color: #f46a6a;
  }
}

.toggle-cols-wrapper {
  background-color: #fff;
  padding: 1%;
}

.in-color {
  color: #34c38f;
}

.float-left {
  float: inline-start !important;
}

.out-color {
  color: #f46a6a;
}

.status-icon {
  font-size: 1.5rem;
}

.dashboard-grid {
  @media only screen and (max-width: 700px) {
    font-size: 0.6rem !important;
  }
}
</style>

<style lang="scss">

.tooltip-container-signinout{
  color: #C1C1C1 !important;
}

.tooltip-text-signinout {
  visibility: hidden;
  width: 152px !important;
  height: 58px !important;
  background-color: #FFFFFF !important;
  color: #787878 !important;
  text-align: center !important;
  border-radius: 6px;
  padding: 16px;
  position: absolute;
  left: 110%;  /* Move to the right of the container */
  top: 50%;
  transform: translateY(-50%);
  opacity: 0;
  transition: opacity 0.3s ease-in-out, transform 0.3s ease-in-out;
  box-shadow: 0px 3px 3px 0px #00000029;
  z-index: 9999;
  font-weight: 400;
  font-size: 12px;
  line-height: 17px;
  /* Text Wrapping */
  white-space: normal !important;  /* Allow text to wrap */
  word-wrap: break-word !important; /* Ensure words break if needed */
  word-break: break-word !important; /* Break long words */
  
}

/* Tooltip Arrow */
/* Show tooltip on hover */
.tooltip-container-signinout:hover .tooltip-text-signinout {
  visibility: visible;
  opacity: 1;
  transform: translateX(-50%) translateY(-5px);
}

.dashboardGridHeight .dx-datagrid {
  height: calc(100vh - 197px);
}
.dashboardGridHeightWithAlert .dx-datagrid {
  height: calc(100vh - 243px);
}

.image-index {
  padding: 0 14px !important;
}

.dx-datagrid-rowsview .dx-row-focused.dx-data-row .dx-command-edit .dx-link,
.dx-datagrid-rowsview .dx-row-focused.dx-data-row>td:not(.dx-focused),
.dx-datagrid-rowsview .dx-row-focused.dx-data-row>tr>td:not(.dx-focused) {
  background: unset;
  color: unset;
}

.attendanceCodeColumn {
  white-space: break-spaces;
}

div[id*="reloadCompliance"] {
  .modal-dialog.modal-md.modal-dialog-scrollable {
    margin-top: 200px;
  }

  div[class*="modal-content"] {
    border-radius: 26px;
  }
}

.dx-item-content.dx-list-item-content {
  white-space: normal;
}

.hideButton a.dx-link.dx-link-edit {
  display: none !important;
}

.waiting-for-approval-style {
  background-color: #ffa50021;
}

.image-viewer {
  width: 600px;
  height: 600px;
  inset-inline-start: 35%;
  top: 10%;
  border-radius: 16px;

  .image-viewer-close {
    font-size: 20px;
    color: #f46a6a;
  }
}

.image-viewer-content {
  img {
    border-radius: 50%;
    width: 350px;
    height: 350px;
  }
}

.dash-imgPosition {
  display: flex;
  justify-items: center;
  align-items: center;
  justify-content: center;
}

.dash-img {
  width: 27px;
  height: 27px;

  & img {
    height: 27px !important;
    width: 27px;
  }
}

.hide-loader .dx-overlay-content.dx-resizable.dx-loadpanel-content {
  display: none !important;
}

.dashboard-grid {
  .dx-rtl .dx-datagrid-content .dx-datagrid-table .dx-row .dx-filter-range-content {
    padding: 13px 32px 7px 7px;
  }
  .smiley-text {
    font-weight: 700 !important;
    font-size: 16px !important;
    line-height: 19px !important;
    margin: auto 0 !important;
  }

  td.dx-cell-focus-disabled.dx-master-detail-cell {
    background: white !important;
    padding-inline-start: 0 !important;
  }

  tbody {
    color: #495057;
  }
  .massaction-ddl {
    margin-inline: 10px;
  }

  .dx-toolbar-after:empty {
    display: none !important;
  }

  @media only screen and (max-width: 1200px) {
    .dx-toolbar .dx-toolbar-items-container {
      display: flex !important;
      flex-direction: column !important;
      align-items: center !important;
      width: fit-content;
      margin: 15px auto !important;
      box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px !important;
      border-radius: 10px !important;

      .dx-toolbar-before,
      .dx-toolbar-after {
        position: static !important;
      }
      .dx-toolbar-before {
        padding-top: 5px !important;
      }
    }
  }
}

.massaction-item {
  font-weight: 400;
  font-size: 16px !important;
  text-align: center;
  line-height: 19px !important;
  padding: 6px !important;
  color: #787878 !important;
}

.user-col,
.dash-comp,
.dash-img {
  display: flex;
  justify-items: center;
  align-items: center;
  justify-content: center;
}

.user-col {
  height: 59px !important;
}

.select-actionsDAsh {
  ul.dropdown-menu.show {
    background: #ffffff !important;
    box-shadow: 0px 3px 3px rgba(0, 0, 0, 0.161) !important;
    border-radius: 6px !important;
    text-align: center !important;
    min-width: 142px !important;
    max-height: 94px !important;
    margin-top: 8px !important;
    overflow-y: scroll !important;
    transform: translate3d(0px, 8px, 0px) !important;
  }

  li.action-padding.text-red {
    a.dropdown-item {
      margin: auto !important;

      font-weight: 400 !important;
      font-size: 16px !important;
      line-height: 19px !important;
      text-align: center !important;
      color: #f46a6a !important;
      // padding-inline-end: 22px !important;
      max-width: 142px !important;
      white-space: normal !important;
      padding: 1px 5px 1px 5px !important;
    }
  }

  a.dropdown-item {
    margin: auto !important;
    font-weight: 400 !important;
    font-size: 16px !important;
    line-height: 19px !important;
    text-align: center !important;
    color: #787878 !important;
    max-width: 142px !important;
    white-space: normal !important;
    padding: 1px 5px 1px 5px !important;
  }

  .dropdown-menu.show::-webkit-scrollbar {
    width: 9px;
  }

  .dropdown-menu.show::-webkit-scrollbar-track {
    background: #ffffff;
    height: 129px;
    border-radius: 8.5px;
    -webkit-box-shadow: #ffff;
  }

  .dropdown-menu.show::-webkit-scrollbar-thumb {
    background: #666666;
    border-radius: 8.5px;
    height: 50px;
  }
}

.center-icon {
  align-items: center;
  justify-content: center;
}

.custom-clo {
  height: 200px;
  width: 20px;
  background-color: blue;
}

.custom-managevisit {
  margin-inline-start: 16px;
  width: 107px;
  height: 27px;
  background: #2680eb;
  border-radius: 12.5px;
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  text-align: center;
  border: none !important;
  color: #ffffff;
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.custom-managevisit:disabled {
  opacity: 0.5;
  color: #c3c3c3;
}

.custom-signinout {
  margin-inline-start: 16px !important;
  width: 107px;
  height: 27px;
  color: #ffffff;
  background: #2680eb;
  border-radius: 72px;
  border: none !important;
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  text-align: center;
}

.custom-signinout:disabled {
  opacity: 0.5;
  color: #c3c3c3;
}

.dashboard-white-bg-sec {
  background-color: white;
  padding-inline-start: 0px;
  border-radius: 8px !important;
}

.dx-toolbar .dx-toolbar-before {
  padding-inline-end: 15px;
  display: flex;
  align-items: center;
}
.d-flex.justify-content-between.dx-template-wrapper.dx-item-content.dx-toolbar-item-content {
  align-items: center;
}

.toolbar-primary {
  background-color: #2680eb;
}

.toolbar-success {
  background-color: #34c38f;
}

.toolbar-alert {
  background-color: #f46a6a;
}

.toolbar-main {
  background-color: #103f5e;
}

.v-line {
  width: 1px;
  height: 23px;
  background-color: #ebebeb;
}

.dx-datagrid-rowsview .dx-selection>td .dx-link {
  color: #a5a5a5;
}

.dx-datagrid-rowsview .dx-selection.dx-row:hover>td .dx-link {
  color: #a5a5a5;
}

.resend-compliance-btn {
  border: none;
  background-color: transparent;
  padding: 0;
  margin-top: 0;
  margin-inline-end: 0;
  margin-bottom: 0;
  margin-inline-start: 8px;
}

.resend-compliance-btn:disabled {
  opacity: 0.5;
  color: #a5a5a5;
}

.dx-checkbox-checked .dx-checkbox-icon {
  background-color: #757575;
}

.dx-checkbox-indeterminate .dx-checkbox-icon {
  background-color: #757575;
}

.dx-checkbox.dx-state-disabled.dx-checkbox-checked {
  .dx-checkbox-icon {
    background: #ffffff;
  }
}

.dx-checkbox.dx-checkbox-checked.dx-state-disabled .dx-checkbox-icon {
  border: 2px solid rgba(0, 0, 0, 0.54);
  border-radius: 2px;
}

.dx-row.dx-selection:has(.dx-checkbox.dx-state-disabled) {
  background-color: #efefef !important;
}

.dx-link.dx-link-edit.dx-state-disabled {
  pointer-events: none;
  cursor: default;
  opacity: 0.38;
}

.modal-content {
  border-radius: 26px !important;
}

[aria-label="Column RFID"] {
  .dx-sort.dx-sort-up,
  .dx-sort.dx-sort-down {
    display: none !important;
  }
}

.grid-smiley-container {
  border-radius: 50%;
  width: 24px;
  height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  svg {
    width: 100%;
    height: 100%;
  }
}

button.custom-managevisit {
  width: 107px;
}

.menu-items-container-seperator-line{
  height:1px !important;
  margin:32px 0px 0px 0px !important;
  background: #EBEBEB !important;
}

</style>
